// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------------------------------
    Datepicker
   ------------------------------------------------- */
.air-datepicker-cell.-year-.-other-decade-, .air-datepicker-cell.-day-.-other-month- {
  color: var(--adp-color-other-month);
}
.-disabled-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-disabled-.-focus-.air-datepicker-cell.-day-.-other-month- {
  color: var(--adp-color-other-month);
}
.-selected-.air-datepicker-cell.-year-.-other-decade-, .-selected-.air-datepicker-cell.-day-.-other-month- {
  color: #fff;
  background: var(--adp-background-color-selected-other-month);
}
.-selected-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-selected-.-focus-.air-datepicker-cell.-day-.-other-month- {
  background: var(--adp-background-color-selected-other-month-focused);
}
.-in-range-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-cell-background-color-in-range);
  color: var(--adp-color);
}
.-in-range-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.-focus-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-cell-background-color-in-range);
}
.-in-range-.-disabled-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.-disabled-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-background-color);
}
.air-datepicker-cell.-year-.-other-decade-:empty, .air-datepicker-cell.-day-.-other-month-:empty {
  background: none;
  border: none;
}

/* -------------------------------------------------
    Datepicker body
   ------------------------------------------------- */
.air-datepicker-body {
  transition: all var(--adp-transition-duration) var(--adp-transition-ease);
}
.air-datepicker-body.-hidden- {
  display: none;
}

/*  Day names
   ------------------------------------------------- */
.air-datepicker-body--day-names {
  display: grid;
  grid-template-columns: repeat(7, var(--adp-day-cell-width));
  margin: 0 0 10px 0;
}

.air-datepicker-body--day-name {
  color: var(--adp-day-name-color);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.air-datepicker-body--day-name.-clickable- {
  cursor: pointer;
}
.air-datepicker-body--day-name.-clickable-:hover {
  color: var(--adp-day-name-color-hover);
}

/*  Cells container
   ------------------------------------------------- */
.air-datepicker-body--cells {
  display: grid;
}
.air-datepicker-body--cells.-days- {
  grid-template-columns: repeat(7, var(--adp-day-cell-width));
  grid-auto-rows: var(--adp-day-cell-height);
}
.air-datepicker-body--cells.-months- {
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: var(--adp-month-cell-height);
  padding: 0 10px;
}
.air-datepicker-body--cells.-years- {
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: var(--adp-year-cell-height);
  padding: 0 10px;
}

/* -------------------------------------------------
    Datepicker vars
   ------------------------------------------------- */
@keyframes remove-hidden {
  0% {
    overflow: hidden;
  }
  100% {
    overflow: inherit;
  }
}
@keyframes bounce2 {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
@keyframes bounce-in-avatar {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  70% {
    transform: translateY(20px);
  }
  100% {
    transform: scale(1) translate(0);
  }
}
@keyframes avatarBubbleAnim {
  0% {
    opacity: 0;
    transform: translateY(10px); /* Move the elements 100% down */
  }
  80% {
    opacity: 1;
    transform: translateY(-10px); /* Move the elements to their original position */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translateY(100%); /* Move the elements 100% down */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes quick {
  0% {
    opacity: 0;
    transform: scale(0);
    overflow: hidden;
  }
  90%, 50% {
    overflow: hidden;
  }
  100% {
    opacity: 1;
    transform: scale(1);
    overflow: inherit;
  }
}
@keyframes bounce-in {
  0% {
    opacity: 0;
    overflow: hidden;
  }
  40% {
    opacity: 1;
    overflow: hidden;
  }
  60% {
    transform: translate(-10px);
  }
  80% {
    transform: translate(-15px);
  }
  100% {
    transform: none;
    overflow: inherit;
  }
}
@keyframes bubbleAnim {
  0% {
    opacity: 0;
    transform: translateY(10%);
  }
  20% {
    opacity: 0;
    transform: translateY(10%);
  }
  100% {
    opacity: 1;
    transform: translate(0%);
  }
}
@keyframes voiceShowAnim {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translate(0%);
  }
}
@keyframes left-to-right-slide-anim {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  80% {
    opacity: 0.5;
    transform: translateX(0px);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
@keyframes right-to-left-slide-anim {
  0% {
    opacity: 0;
    transform: translateX(100%); /* Move the elements 100% down */
  }
  80% {
    opacity: 0.5;
    transform: translateX(10px); /* Move the elements to their original position */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes recording {
  from {
    transform: scale(1.1);
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 1px rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 5px rgba(75, 78, 222, 0.2);
  }
  50% {
    transform: none;
  }
  to {
    transform: scale(1.1);
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 6px rgba(75, 78, 222, 0), 0 0 0 10px rgba(75, 78, 222, 0);
  }
}
@keyframes voiceAnim {
  from {
    transform: scale(1.1);
  }
  0% {
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 1px rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 5px rgba(75, 78, 222, 0.2);
  }
  50% {
    transform: none;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 4px rgba(75, 78, 222, 0.2), 0 0 0 20px rgba(75, 78, 222, 0), 0 0 0 30px rgba(75, 78, 222, 0);
    transform: scale(1.1);
  }
  to {
    transform: scale(1.1);
  }
}
@keyframes closeBottomToTopAnim {
  0% {
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(100%);
    display: none;
  }
}
@keyframes slideBottomToTopAnim {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  80% {
    opacity: 1;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.slideInRight {
  -webkit-animation-name: slideInRight;
  animation-name: slideInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible;
  }
  80% {
    -webkit-transform: translateX(0);
    transform: translateX(2px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible;
  }
  80% {
    -webkit-transform: translateX(0);
    transform: translateX(2px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
.scale-up-br {
  -webkit-animation: scale-up-br 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: scale-up-br 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.scale-out-br {
  -webkit-animation: scale-out-br 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  animation: scale-out-br 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

@-webkit-keyframes scale-out-br {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@keyframes scale-out-br {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@-webkit-keyframes scale-up-br {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
@keyframes scale-up-br {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
@-webkit-keyframes spinLoader {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spinLoader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rotateIn {
  -webkit-animation-name: rotateIn;
  animation-name: rotateIn;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, -200deg);
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}
@keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, -200deg);
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}
@keyframes dot-flashing {
  0% {
    background-color: var(--sdk-gloabl-bg-secondary);
  }
  50%, 100% {
    opacity: 0.5;
  }
}
.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: flex;
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }
  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }
  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }
  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }
  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInUp {
  0% {
    opacity: 1;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.slideOutDown {
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes slideOutDown {
  0% {
    -webkit-transform: translateY(-10%);
    transform: translateY(-10%);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
:root {
  --sdk-gloabl-primary-color:var(--chat-sdk-branding--global-primary-color);
  --sdk-gloabl-secondary-color:var(--chat-sdk-branding--global-secondary-color);
  --sdk-global-primary-text:var(--chat-sdk-branding--global-primary-text);
  --sdk-global-secondary-text:var(--chat-sdk-branding--global-secondary-text);
  --theme-panel-wigdet-primary-bg-color:var(--sdk-gloabl-primary-color);
  --theme-panel-wigdet-secondary-bg-color:var(--sdk-gloabl-secondary-color);
  --theme-panel-wigdet-primary-text-color:var(--sdk-global-primary-text);
  --theme-panel-wigdet-secondary-text-color:var(--sdk-global-secondary-text) ;
  --panel-wigdet-primary-bg-color:var(--theme-panel-wigdet-primary-bg-color);
  --panel-wigdet-secondary-bg-color:var(--theme-panel-wigdet-secondary-bg-color);
  --panel-wigdet-primary-text-color:var(--theme-panel-wigdet-primary-text-color);
  --panel-wigdet-secondary-text-color:var(--theme-panel-wigdet-secondary-text-color);
  --panel-wigdet-border-color:var(--panel-wigdet-secondary-bg-color);
  --panel-wigdet-white-bg-color:var(--chat-sdk-branding--widget_panel-colors-bg_color);
  --panel-wigdet-white-text-color:#fff;
  --panel-wigdet-left-menu-bg:var(--chat-sdk-branding--widget_panel-colors-bg_color);
  --panel-wigdet-left-menu-selected-bg:var(--chat-sdk-branding--widget_panel-colors-sel_bg_color);
  --panel-wigdet-left-menu-font-clr:var(--chat-sdk-branding--widget_panel-colors-color);
  --panel-wigdet-left-menu-selected-font-clr:var(--chat-sdk-branding--widget_panel-colors-sel_color);
  --global-font-family: var(--chat-sdk-branding--global-font-family);
  --sdk-global-theme-color:var(--sdk-gloabl-primary-color);
  --sdk-gloabl-bg-secondary:var(--sdk-gloabl-secondary-color);
  --sdk-global-white:var(--sdk-global-secondary-text);
  --sdk-global-white-bg:var(--chat-sdk-branding--body-white-background);
  --sdk-gloabl-text-color:var(--sdk-global-primary-text);
  --sdk-gloabl-text-desc-color:var(--sdk-global-primary-text);
  --sdk-gloabl-border-color:var(--sdk-gloabl-secondary-color);
  --sdk-scrollbar-bg:var(--sdk-gloabl-bg-secondary);
  --avatar-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);
  --avatar-send-msg-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);
  --avatar-icon-color:var(--chat-sdk-branding--chat_bubble-bg-secondary_color);
  --avatar-text-colr:var(--sdk-gloabl-text-color);
  --chat-widget-box-shadow:0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  --agent-joined-bg:var(--sdk-gloabl-bg-secondary);
  --agent-joined-border:var(--sdk-gloabl-border-color);
  --agent-joined-text-color:var(--sdk-gloabl-text-color);
  --welcome-bg:var(--sdk-global-white-bg);
  --welcome-shadow:0px 4px 12px 2px rgba(32,33,36,0.12);
  --welcome-header-bg: var(--chat-sdk-branding--welcome_screen-background-color);
  --welcome-header-text-color:var(--chat-sdk-branding--welcome_screen-top_fonts-color);
  --welcome-start-conv-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-bot-bg:var(--sdk-global-theme-color);
  --welcome-start-conv-bot-title:var(--sdk-gloabl-text-color);
  --welcome-start-conv-bot-desc:var(--sdk-gloabl-text-desc-color);
  --welcome-start-conv-quick-btn-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-quick-btn-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-quick-btn-text:var(--sdk-gloabl-text-color);
  --welcome-start-conv-search-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-search-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-button-bg:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_button_color);
  --welcome-start-conv-button-border:var(--sdk-global-theme-color);
  --welcome-start-conv-button-color:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_text_color);
  --welcome-footer-bg:var(--chat-sdk-branding--welcome_screen-bottom_background-color);
  --welecome-footer-text-color:var(--sdk-gloabl-text-color);
  --chat-widget-header-bg:var(--chat-sdk-branding--header-bg-bg_color);
  --chat-widget-header-border:var(--sdk-gloabl-border-color);
  --chat-widget-header-bg-large:linear-gradient(180deg, var(--sdk-global-theme-color) 0%, var(--sdk-global-theme-color) 40.67%, rgba(255, 255, 255, 0) 80.38%);
  --chat-widget-header-bg-large-info-bg:var(--sdk-global-white-bg);
  --chat-widget-header-bg-large-actions-color:var(--sdk-global-white);
  --chat-widget-header-bot-name-color:var(--chat-sdk-branding--header-title-color);
  --chat-widget-header-bot-name-desc:var(--chat-sdk-branding--header-sub_title-color);
  --chat-widget-header-actions-color:var(--chat-sdk-branding--header-icons-color);
  --chat-widget-header-img-border:var(--sdk-global-white);
  --chat-widget-body-bg:var(--chat-sdk-branding--body-background-bg);
  --chat-widget-footer-bg: var(--sdk-global-white-bg);
  --chat-widget-compose-bar-bg:var(--chat-sdk-branding--footer-bg-bg_color);
  --chat-widget-compose-bar-border:var(--sdk-gloabl-border-color);
  --chat-widget-compose-bar-text-area-bg:var(--chat-sdk-branding--footer-compose_bar-bg_color);
  --chat-widget-compose-bar-text-area-border:var(--chat-sdk-branding--footer-compose_bar-outline-color);
  --chat-widget-compose-bar-text-area-color:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-text-area-placeholder-color:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-voice-speak-info-text:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-voice-icon-bg:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-icon-border:var(--sdk-global-white-bg);
  --chat-widget-compose-bar-voice-icon-color:var(--sdk-global-white);
  --chat-widget-compose-bar-voice-speak-msg-bg:var(--sdk-global-white-bg);
  --chat-widget-compose-bar-voice-speak-msg-selected-bg:var(--sdk-gloabl-bg-secondary);
  --chat-widget-compose-bar-voice-speak-msg-color:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-speak-msg-border:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-recording-animation-shadow:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 1px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 5px rgba(var(--sdk-global-theme-color), 0.2);
  --chat-widget-compose-bar-voice-recording-animation-shadow-zoom:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2),0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2),0 0 0 6px rgba(var(--sdk-global-theme-color), 0),0 0 0 10px rgba(var(--sdk-global-theme-color), 0);
  --chat-widget-compose-bar-menu-icon-color:var(--chat-sdk-branding--footer-menu_icon-color);
  --chat-widget-compose-bar-other-icons:var(--chat-sdk-branding--footer-icons-color);
  --bot-bubble-text-color:var(--sdk-gloabl-text-color);
  --bot-bubble-msg-bg:var(--chat-sdk-branding--body-bot_message-bg_color);
  --bot-bubble-msg-bg-hover:var(--chat-sdk-branding--body-bot_message-bg_color);
  --bot-bubble-msg-color:var(--chat-sdk-branding--body-bot_message-color);
  --bot-bubble-img-border:var(--sdk-global-white-bg);
  --name-color:var(--chat-sdk-branding--body-agent_message-title_color);
  --time-stamp-color:var(--chat-sdk-branding--body-time_stamp-color);
  --agent-bubble-text-color:var(--sdk-gloabl-text-color);
  --agent-bubble-msg-bg:var(--chat-sdk-branding--body-user_message-bg_color);
  --agent-bubble-msg-bg-hover:var(--chat-sdk-branding--body-user_message-bg_color);
  --agent-bubble-msg-color:var(--chat-sdk-branding--body-user_message-color);
  --agent-bubble-img-border:var(--sdk-global-white-bg);
  --agent-bubble-read-status-icon-color:#22C55E;
  --date-seperator-bg:var(--sdk-gloabl-bg-secondary);
  --date-seperator-border:var(--sdk-gloabl-border-color);
  --date-seperator-line-border:var(--sdk-gloabl-border-color);
  --date-seperator-color:var(--sdk-gloabl-text-color);
  --button-bg-color: var(--chat-sdk-branding--body-buttons-bg_color);
  --button-text-color: var(--chat-sdk-branding--body-buttons-color);
  --button-temp-bg:var(--sdk-global-white-bg);
  --button-temp-border:var(--sdk-gloabl-border-color);
  --button-temp-color:var(--sdk-gloabl-text-color);
  --button-temp-bg-hover:var(--sdk-gloabl-bg-secondary);
  --button-temp-bg-variation-1:var(--sdk-gloabl-bg-secondary);
  --button-temp-variation-1-border:transparent;
  --button-temp-variation-1-color:var(--button-bg-color);
  --button-temp-bg-variation-1-hover:linear-gradient(0deg, rgba(75, 78, 222, 0.07) 0%, rgba(75, 78, 222, 0.07) 100%), var(--sdk-gloabl-bg-secondary);
  --button-temp-bg-variation-2:var(--button-bg-color);
  --button-temp-variation-2-border:var(--button-bg-color);
  --button-temp-variation-2-color:var(--button-text-color);
  --button-temp-bg-variation-2-hover:linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), var(--button-bg-color);
  --card-main-wrapper-bg:var(--sdk-gloabl-bg-secondary);
  --card-main-wrapper-border:var(--sdk-gloabl-border-color);
  --card-heading-title:var(--sdk-gloabl-text-color);
  --card-temp-border:var(--sdk-gloabl-border-color);
  --card-temp-bg:var(--sdk-global-white-bg);
  --card-temp-color:var(--sdk-gloabl-text-color);
  --card-temp-h1-color:var(--sdk-gloabl-text-color);
  --card-temp-p-color:var(--sdk-gloabl-text-color);
  --card-temp-view-more-bg:var(--sdk-global-white-bg);
  --card-temp-view-more-color:var(--sdk-global-theme-color);
  --card-temp-view-more-border:var(--sdk-global-theme-color);
  --card-temp-border-divided-bg:var(--sdk-gloabl-border-color);
  --form-temp-bg:var(--sdk-gloabl-bg-secondary);
  --form-temp--text-color:var(--sdk-gloabl-text-color);
  --form-temp-input-bg:var(--sdk-global-white-bg);
  --form-temp-input-box-shadow:0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  --form-temp-input-placeholder:var(--sdk-gloabl-text-color);
  --table-border:var(--sdk-gloabl-border-color);
  --table-header-text-color:var(--sdk-gloabl-text-color);
  --table-body-tr-bg:var(--sdk-gloabl-bg-secondary);
  --table-desc-text-color:var(--sdk-gloabl-text-color);
  --radio-desc-text-clr:var(--sdk-gloabl-text-color);
  --radio-border:var(--sdk-gloabl-border-color);
  --radio-bg:var(--sdk-global-white-bg);
  --radio-checked-shadow:inset 0 0 0 6px var(--sdk-global-white-bg);
}

.kr-button-primary {
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  width: 100%;
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  background: var(--button-temp-bg-variation-2);
  border: 1px solid var(--button-temp-variation-2-border);
  color: var(--button-temp-variation-2-color);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-primary.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-primary:hover {
  background: var(--button-temp-bg-variation-2-hover);
}
.kr-button-primary:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.kr-button-secondary {
  width: 100%;
  background: var(--button-temp-bg);
  border: 1px solid var(--button-temp-border);
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  color: var(--button-temp-color);
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-secondary.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-secondary:hover {
  background: var(--button-temp-bg-hover);
}

.kr-button-blue-light {
  width: 100%;
  background: var(--button-bg-color);
  border: 1px solid var(--button-bg-color);
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  color: var(--button-text-color);
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-blue-light svg path {
  fill: var(--button-bg-color);
}
.kr-button-blue-light.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-blue-light:hover {
  background: var(--button-bg-color);
}

.kore-chat-window-main-section .chart-disp-val {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section .chart-axis-line {
  stroke: var(--sdk-gloabl-text-color);
}
.kore-chat-window-main-section .legend-title {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section polyline {
  stroke: var(--sdk-gloabl-text-color);
}
.kore-chat-window-main-section .mouse-per-line text {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section .legend-value {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}

.air-datepicker {
  --adp-font-family: var(--global-font-family);
  --adp-font-size: 14px;
  --adp-width: 100%;
  --adp-z-index: 100;
  --adp-padding: 4px;
  --adp-grid-areas:
    'nav'
    'body'
    'timepicker'
    'buttons';
  --adp-transition-duration: .3s;
  --adp-transition-ease: ease-out;
  --adp-transition-offset: 8px;
  --adp-background-color: var(--sdk-global-white-bg);
  --adp-background-color-hover: var(--sdk-gloabl-bg-secondary);
  --adp-background-color-active: var(--sdk-gloabl-bg-secondary);
  --adp-background-color-in-range: var(--sdk-gloabl-text-color);
  --adp-background-color-in-range-focused: var(--sdk-gloabl-text-color);
  --adp-background-color-selected-other-month-focused: var(--sdk-global-theme-color);
  --adp-background-color-selected-other-month: var(--sdk-global-theme-color);
  --adp-color: var(--sdk-gloabl-text-color);
  --adp-color-secondary: var(--sdk-gloabl-text-color);
  --adp-accent-color: var(--sdk-gloabl-text-color);
  --adp-color-current-date: var(--adp-accent-color);
  --adp-color-other-month: #9AA4B2;
  --adp-color-disabled: #aeaeae;
  --adp-color-disabled-in-range: #939393;
  --adp-color-other-month-hover: var(--sdk-gloabl-text-color);
  --adp-border-color: #E4E5E7;
  --adp-border-color-inner: #E4E5E7;
  --adp-border-radius: 8px;
  --adp-border-color-inline: #E4E5E7;
  --adp-nav-height: 36px;
  --adp-nav-arrow-color: var(--adp-color-secondary);
  --adp-nav-action-size: 36px;
  --adp-nav-color-secondary: var(--adp-color-secondary);
  --adp-day-name-color: var(--sdk-gloabl-text-color);
  --adp-day-name-color-hover: var(--sdk-global-theme-color);
  --adp-day-cell-width: 1fr;
  --adp-day-cell-height: 42px;
  --adp-month-cell-height: 40px;
  --adp-year-cell-height: 56px;
  --adp-pointer-size: 10px;
  --adp-poiner-border-radius: 2px;
  --adp-pointer-offset: 14px;
  --adp-cell-border-radius: 100px;
  --adp-cell-background-color-hover: var(--adp-background-color-hover);
  --adp-cell-background-color-selected: var(--sdk-global-theme-color);
  --adp-cell-background-color-selected-hover: var(--sdk-global-theme-color);
  --adp-cell-background-color-in-range: var(--sdk-gloabl-border-color);
  --adp-cell-background-color-in-range-hover: var(--sdk-gloabl-border-color);
  --adp-btn-height: 32px;
  --adp-btn-color: var(--adp-accent-color);
  --adp-btn-color-hover: var(--adp-color);
  --adp-btn-border-radius: var(--adp-border-radius);
  --adp-btn-background-color-hover: var(--adp-background-color-hover);
  --adp-btn-background-color-active: var(--adp-background-color-active);
  --adp-time-track-height: 1px;
  --adp-time-track-color: #dedede;
  --adp-time-track-color-hover: #b1b1b1;
  --adp-time-thumb-size: 12px;
  --adp-time-padding-inner: 10px;
  --adp-time-day-period-color: var(--adp-color-secondary);
  --adp-mobile-font-size: 16px;
  --adp-mobile-nav-height: 40px;
  --adp-mobile-width: 320px;
  --adp-mobile-day-cell-height: 38px;
  --adp-mobile-month-cell-height: 48px;
  --adp-mobile-year-cell-height: 64px;
}

.air-datepicker-overlay {
  --adp-overlay-background-color: rgba(0, 0, 0, .3);
  --adp-overlay-transition-duration: .3s;
  --adp-overlay-transition-ease: ease-out;
  --adp-overlay-z-index: 99;
}

/* -------------------------------------------------
    Datepicker buttons
   ------------------------------------------------- */
.air-datepicker-buttons {
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
}

.air-datepicker-button {
  display: inline-flex;
  color: var(--adp-btn-color);
  border-radius: var(--adp-btn-border-radius);
  cursor: pointer;
  height: var(--adp-btn-height);
  border: none;
  background: rgba(255, 255, 255, 0);
}
.air-datepicker-button:hover {
  color: var(--adp-btn-color-hover);
  background: var(--adp-btn-background-color-hover);
}
.air-datepicker-button:focus {
  color: var(--adp-btn-color-hover);
  background: var(--adp-btn-background-color-hover);
  outline: none;
}
.air-datepicker-button:active {
  background: var(--adp-btn-background-color-active);
}
.air-datepicker-button span {
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

/* -------------------------------------------------
    Datepicker nav
   ------------------------------------------------- */
.air-datepicker-nav {
  display: flex;
  justify-content: space-between;
  border-bottom: 0px solid var(--adp-border-color-inner);
  min-height: var(--adp-nav-height);
  padding: var(--adp-padding);
  box-sizing: content-box;
}
.-only-timepicker- .air-datepicker-nav {
  display: none;
}

.air-datepicker-nav--title,
.air-datepicker-nav--action {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

/*  Navigation action
   ------------------------------------------------- */
.air-datepicker-nav--action {
  width: var(--adp-nav-action-size);
  border-radius: var(--adp-border-radius);
  user-select: none;
}
.air-datepicker-nav--action:hover {
  background: var(--adp-background-color-hover);
}
.air-datepicker-nav--action:active {
  background: var(--adp-background-color-active);
}
.air-datepicker-nav--action.-disabled- {
  visibility: hidden;
}
.air-datepicker-nav--action svg {
  width: 32px;
  height: 32px;
}
.air-datepicker-nav--action path {
  fill: none;
  stroke: var(--adp-nav-arrow-color);
  stroke-width: 2px;
}

/*  Navigation title
   ------------------------------------------------- */
.air-datepicker-nav--title {
  border-radius: var(--adp-border-radius);
  padding: 0 8px;
  color: var(--adp-color);
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.air-datepicker-nav--title i {
  font-style: normal;
  color: var(--adp-color);
  margin-left: 0.3em;
}
.air-datepicker-nav--title:hover {
  background: var(--adp-background-color-hover);
}
.air-datepicker-nav--title:active {
  background: var(--adp-background-color-active);
}
.air-datepicker-nav--title.-disabled- {
  cursor: default;
  background: none;
}

.air-datepicker-cell.-year-.-other-decade-, .air-datepicker-cell.-day-.-other-month- {
  color: var(--adp-color-other-month);
}
.-disabled-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-disabled-.-focus-.air-datepicker-cell.-day-.-other-month- {
  color: var(--adp-color-other-month);
}
.-selected-.air-datepicker-cell.-year-.-other-decade-, .-selected-.air-datepicker-cell.-day-.-other-month- {
  color: #fff;
  background: var(--adp-background-color-selected-other-month);
}
.-selected-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-selected-.-focus-.air-datepicker-cell.-day-.-other-month- {
  background: var(--adp-background-color-selected-other-month-focused);
}
.-in-range-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-cell-background-color-in-range);
  color: var(--adp-color);
}
.-in-range-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.-focus-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-cell-background-color-in-range);
}
.-in-range-.-disabled-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.-disabled-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-background-color);
}
.air-datepicker-cell.-year-.-other-decade-:empty, .air-datepicker-cell.-day-.-other-month-:empty {
  background: none;
  border: none;
}

/* -------------------------------------------------
    Datepicker cell
   ------------------------------------------------- */
.air-datepicker-cell {
  border-radius: var(--adp-cell-border-radius);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  z-index: 1;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
}
.air-datepicker-cell.-focus- {
  background: var(--adp-cell-background-color-hover);
}
.air-datepicker-cell.-current- {
  color: var(--adp-color-current-date);
  background: var(--adp-background-color-hover);
}
.air-datepicker-cell.-current-::before {
  content: "";
  position: absolute;
  background: var(--sdk-global-theme-color);
  bottom: 4px;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  flex-shrink: 0;
}
.air-datepicker-cell.-current-.-focus- {
  color: var(--adp-color);
}
.air-datepicker-cell.-current-.-in-range- {
  color: var(--adp-color-current-date);
}
.air-datepicker-cell.-disabled- {
  cursor: default;
  color: var(--adp-color-disabled);
}
.air-datepicker-cell.-disabled-.-focus- {
  color: var(--adp-color-disabled);
}
.air-datepicker-cell.-disabled-.-in-range- {
  color: var(--adp-color-disabled-in-range);
  background-color: var(--adp-background-color);
}
.air-datepicker-cell.-disabled-.-current-.-focus- {
  color: var(--adp-color-disabled);
}
.air-datepicker-cell.-in-range- {
  background: var(--adp-cell-background-color-in-range);
}
.air-datepicker-cell.-in-range-:hover {
  background: var(--adp-cell-background-color-in-range-hover);
}
.air-datepicker-cell.-range-from- {
  background-color: var(--adp-cell-background-color-in-range);
  border-radius: var(--adp-cell-border-radius);
}
.air-datepicker-cell.-range-to- {
  background-color: var(--adp-cell-background-color-in-range);
  border-radius: var(--adp-cell-border-radius);
}
.air-datepicker-cell.-range-to-.-range-from- {
  border-radius: var(--adp-cell-border-radius);
}
.air-datepicker-cell.-selected- {
  color: var(--sdk-global-white);
  border: none;
  background: var(--adp-cell-background-color-selected);
}
.air-datepicker-cell.-selected-.-current- {
  color: var(--sdk-global-white);
  background: var(--adp-cell-background-color-selected);
}
.air-datepicker-cell.-selected-.-focus- {
  background: var(--adp-cell-background-color-selected-hover);
}
.air-datepicker-cell.-month- {
  width: auto;
  height: auto;
  margin: 2px;
  border-radius: 4px !important;
}
.air-datepicker-cell.-year- {
  width: auto;
  height: auto;
  margin: 2px;
  border-radius: 4px !important;
}

/*  Day cell
   ------------------------------------------------- */
/*  Year cell
   ------------------------------------------------- */
/* -------------------------------------------------
    Timepicker
   ------------------------------------------------- */
.air-datepicker-time {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-column-gap: 12px;
  align-items: center;
  position: relative;
  margin: 18px;
  padding: 50px 0;
}
.-only-timepicker- .air-datepicker-time {
  border-top: none;
}

.air-datepicker-time--current {
  display: flex;
  align-items: center;
  flex: 1;
  font-size: 14px;
  text-align: center;
}

.air-datepicker-time--current-colon {
  margin: 0 2px 3px;
  line-height: 1;
}

.air-datepicker-time--current-hours,
.air-datepicker-time--current-minutes {
  line-height: 1;
  font-size: 19px;
  font-family: "Century Gothic", CenturyGothic, AppleGothic, sans-serif;
  position: relative;
  z-index: 1;
}
.air-datepicker-time--current-hours:after,
.air-datepicker-time--current-minutes:after {
  content: "";
  background: var(--adp-background-color-hover);
  border-radius: var(--adp-border-radius);
  position: absolute;
  left: -2px;
  top: -3px;
  right: -2px;
  bottom: -2px;
  z-index: -1;
  opacity: 0;
}
.air-datepicker-time--current-hours.-focus-:after,
.air-datepicker-time--current-minutes.-focus-:after {
  opacity: 1;
}

.air-datepicker-time--current-ampm {
  text-transform: uppercase;
  align-self: flex-end;
  color: var(--adp-time-day-period-color);
  margin-left: 6px;
  font-size: 11px;
  margin-bottom: 1px;
}

.air-datepicker-time--row {
  display: flex;
  align-items: center;
  font-size: 11px;
  height: 17px;
  background: linear-gradient(to right, var(--adp-time-track-color), var(--adp-time-track-color)) left 50%/100% var(--adp-time-track-height) no-repeat;
}
.air-datepicker-time--row:first-child {
  margin-bottom: 4px;
}
.air-datepicker-time--row input[type=range] {
  background: none;
  cursor: pointer;
  flex: 1;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  -webkit-appearance: none;
}
.air-datepicker-time--row input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
.air-datepicker-time--row input[type=range]::-ms-tooltip {
  display: none;
}
.air-datepicker-time--row input[type=range]:hover::-webkit-slider-thumb {
  border-color: var(--adp-time-track-color-hover);
}
.air-datepicker-time--row input[type=range]:hover::-moz-range-thumb {
  border-color: var(--adp-time-track-color-hover);
}
.air-datepicker-time--row input[type=range]:hover::-ms-thumb {
  border-color: var(--adp-time-track-color-hover);
}
.air-datepicker-time--row input[type=range]:focus {
  outline: none;
}
.air-datepicker-time--row input[type=range]:focus::-webkit-slider-thumb {
  background: var(--adp-cell-background-color-selected);
  border-color: var(--adp-cell-background-color-selected);
}
.air-datepicker-time--row input[type=range]:focus::-moz-range-thumb {
  background: var(--adp-cell-background-color-selected);
  border-color: var(--adp-cell-background-color-selected);
}
.air-datepicker-time--row input[type=range]:focus::-ms-thumb {
  background: var(--adp-cell-background-color-selected);
  border-color: var(--adp-cell-background-color-selected);
}
.air-datepicker-time--row input[type=range]::-webkit-slider-thumb {
  box-sizing: border-box;
  height: 12px;
  width: 12px;
  border-radius: 3px;
  border: 1px solid var(--adp-time-track-color);
  background: #fff;
  cursor: pointer;
  transition: background var(--adp-transition-duration);
}
.air-datepicker-time--row input[type=range]::-moz-range-thumb {
  box-sizing: border-box;
  height: 12px;
  width: 12px;
  border-radius: 3px;
  border: 1px solid var(--adp-time-track-color);
  background: #fff;
  cursor: pointer;
  transition: background var(--adp-transition-duration);
}
.air-datepicker-time--row input[type=range]::-ms-thumb {
  box-sizing: border-box;
  height: 12px;
  width: 12px;
  border-radius: 3px;
  border: 1px solid var(--adp-time-track-color);
  background: #fff;
  cursor: pointer;
  transition: background var(--adp-transition-duration);
}
.air-datepicker-time--row input[type=range]::-webkit-slider-thumb {
  margin-top: calc(var(--adp-time-thumb-size) / 2 * -1);
}
.air-datepicker-time--row input[type=range]::-webkit-slider-runnable-track {
  border: none;
  height: var(--adp-time-track-height);
  cursor: pointer;
  color: transparent;
  background: transparent;
}
.air-datepicker-time--row input[type=range]::-moz-range-track {
  border: none;
  height: var(--adp-time-track-height);
  cursor: pointer;
  color: transparent;
  background: transparent;
}
.air-datepicker-time--row input[type=range]::-ms-track {
  border: none;
  height: var(--adp-time-track-height);
  cursor: pointer;
  color: transparent;
  background: transparent;
}
.air-datepicker-time--row input[type=range]::-ms-fill-lower {
  background: transparent;
}
.air-datepicker-time--row input[type=range]::-ms-fill-upper {
  background: transparent;
}
.air-datepicker {
  border-radius: 8px;
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  background: var(--adp-background-color);
  border: 1px solid var(--adp-border-color);
  border-radius: var(--adp-border-radius);
  box-sizing: content-box;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, max-content);
  grid-template-areas: var(--adp-grid-areas);
  font-family: var(--adp-font-family), sans-serif;
  font-size: var(--adp-font-size);
  color: var(--adp-color);
  width: var(--adp-width);
  position: absolute;
  transition: opacity var(--adp-transition-duration) var(--adp-transition-ease), transform var(--adp-transition-duration) var(--adp-transition-ease);
  z-index: var(--adp-z-index);
}
.air-datepicker:not(.-custom-position-) {
  opacity: 0;
}
.air-datepicker.-from-top- {
  transform: translateY(calc(var(--adp-transition-offset) * -1));
}
.air-datepicker.-from-right- {
  transform: translateX(var(--adp-transition-offset));
}
.air-datepicker.-from-bottom- {
  transform: translateY(var(--adp-transition-offset));
}
.air-datepicker.-from-left- {
  transform: translateX(calc(var(--adp-transition-offset) * -1));
}
.air-datepicker.-active-:not(.-custom-position-) {
  transform: translate(0, 0);
  opacity: 1;
}
.air-datepicker.-active-.-custom-position- {
  transition: none;
}
.air-datepicker.-inline- {
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  position: static;
  left: auto;
  right: auto;
  opacity: 1;
  transform: none;
}
.air-datepicker.-inline- .air-datepicker--pointer {
  display: none;
}
.air-datepicker.-is-mobile- {
  --adp-font-size: var(--adp-mobile-font-size);
  --adp-day-cell-height: var(--adp-mobile-day-cell-height);
  --adp-month-cell-height: var(--adp-mobile-month-cell-height);
  --adp-year-cell-height: var(--adp-mobile-year-cell-height);
  --adp-nav-height: var(--adp-mobile-nav-height);
  --adp-nav-action-size: var(--adp-mobile-nav-height);
  position: fixed;
  width: var(--adp-mobile-width);
}
.air-datepicker.-is-mobile- * {
  -webkit-tap-highlight-color: transparent;
}
.air-datepicker.-is-mobile- .air-datepicker--pointer {
  display: none;
}
.air-datepicker.-is-mobile-:not(.-custom-position-) {
  transform: translate(-50%, calc(-50% + var(--adp-transition-offset)));
}
.air-datepicker.-is-mobile-.-active-:not(.-custom-position-) {
  transform: translate(-50%, -50%);
}
.air-datepicker.-custom-position- {
  transition: none;
}

.air-datepicker-global-container {
  position: absolute;
  left: 0;
  top: 0;
}

.air-datepicker--pointer {
  --pointer-half-size: calc(var(--adp-pointer-size) / 2);
  position: absolute;
  width: var(--adp-pointer-size);
  height: var(--adp-pointer-size);
  z-index: -1;
}
.air-datepicker--pointer:after {
  content: "";
  position: absolute;
  background: #fff;
  border-top: 1px solid var(--adp-border-color-inline);
  border-right: 1px solid var(--adp-border-color-inline);
  border-top-right-radius: var(--adp-poiner-border-radius);
  width: var(--adp-pointer-size);
  height: var(--adp-pointer-size);
  box-sizing: border-box;
}
.-top-left- .air-datepicker--pointer, .-top-center- .air-datepicker--pointer, .-top-right- .air-datepicker--pointer, [data-popper-placement^=top] .air-datepicker--pointer {
  top: calc(100% - var(--pointer-half-size) + 1px);
}
.-top-left- .air-datepicker--pointer:after, .-top-center- .air-datepicker--pointer:after, .-top-right- .air-datepicker--pointer:after, [data-popper-placement^=top] .air-datepicker--pointer:after {
  transform: rotate(135deg);
}
.-right-top- .air-datepicker--pointer, .-right-center- .air-datepicker--pointer, .-right-bottom- .air-datepicker--pointer, [data-popper-placement^=right] .air-datepicker--pointer {
  right: calc(100% - var(--pointer-half-size) + 1px);
}
.-right-top- .air-datepicker--pointer:after, .-right-center- .air-datepicker--pointer:after, .-right-bottom- .air-datepicker--pointer:after, [data-popper-placement^=right] .air-datepicker--pointer:after {
  transform: rotate(225deg);
}
.-bottom-left- .air-datepicker--pointer, .-bottom-center- .air-datepicker--pointer, .-bottom-right- .air-datepicker--pointer, [data-popper-placement^=bottom] .air-datepicker--pointer {
  bottom: calc(100% - var(--pointer-half-size) + 1px);
}
.-bottom-left- .air-datepicker--pointer:after, .-bottom-center- .air-datepicker--pointer:after, .-bottom-right- .air-datepicker--pointer:after, [data-popper-placement^=bottom] .air-datepicker--pointer:after {
  transform: rotate(315deg);
}
.-left-top- .air-datepicker--pointer, .-left-center- .air-datepicker--pointer, .-left-bottom- .air-datepicker--pointer, [data-popper-placement^=left] .air-datepicker--pointer {
  left: calc(100% - var(--pointer-half-size) + 1px);
}
.-left-top- .air-datepicker--pointer:after, .-left-center- .air-datepicker--pointer:after, .-left-bottom- .air-datepicker--pointer:after, [data-popper-placement^=left] .air-datepicker--pointer:after {
  transform: rotate(45deg);
}
.-top-left- .air-datepicker--pointer, .-bottom-left- .air-datepicker--pointer {
  left: var(--adp-pointer-offset);
}
.-top-right- .air-datepicker--pointer, .-bottom-right- .air-datepicker--pointer {
  right: var(--adp-pointer-offset);
}
.-top-center- .air-datepicker--pointer, .-bottom-center- .air-datepicker--pointer {
  left: calc(50% - var(--adp-pointer-size) / 2);
}
.-left-top- .air-datepicker--pointer, .-right-top- .air-datepicker--pointer {
  top: var(--adp-pointer-offset);
}
.-left-bottom- .air-datepicker--pointer, .-right-bottom- .air-datepicker--pointer {
  bottom: var(--adp-pointer-offset);
}
.-left-center- .air-datepicker--pointer, .-right-center- .air-datepicker--pointer {
  top: calc(50% - var(--adp-pointer-size) / 2);
}

.air-datepicker--navigation {
  grid-area: nav;
}

.air-datepicker--content {
  box-sizing: content-box;
  padding: var(--adp-padding);
  grid-area: body;
}
.-only-timepicker- .air-datepicker--content {
  display: none;
}

.air-datepicker--time {
  grid-area: timepicker;
}

.air-datepicker--buttons {
  grid-area: buttons;
}

.air-datepicker--buttons,
.air-datepicker--time {
  padding: var(--adp-padding);
  border-top: 1px solid var(--adp-border-color-inner);
}

/*  Overlay
   ------------------------------------------------- */
.air-datepicker-overlay {
  position: fixed;
  background: var(--adp-overlay-background-color);
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  opacity: 0;
  transition: opacity var(--adp-overlay-transition-duration) var(--adp-overlay-transition-ease), left 0s, height 0s, width 0s;
  transition-delay: 0s, var(--adp-overlay-transition-duration), var(--adp-overlay-transition-duration), var(--adp-overlay-transition-duration);
  z-index: var(--adp-overlay-z-index);
}
.air-datepicker-overlay.-active- {
  opacity: 1;
  width: 100%;
  height: 100%;
  transition: opacity var(--adp-overlay-transition-duration) var(--adp-overlay-transition-ease), height 0s, width 0s;
}

.menu-wrapper-data-actions {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.menu-wrapper-data-actions .actions-slider-header-menu {
  display: flex;
  align-items: center;
  padding: 14px 15px;
  gap: 10px;
  flex-shrink: 0;
}
.menu-wrapper-data-actions .actions-slider-header-menu h1 {
  width: 100%;
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.menu-wrapper-data-actions .actions-slider-header-menu .menu-close {
  width: 16px;
  height: 16px;
  border: 0;
  background: transparent;
  padding: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.menu-wrapper-data-actions .actions-slider-header-menu .menu-close svg path {
  fill: var(--sdk-gloabl-text-color);
}
.menu-wrapper-data-actions .iner-data-scroll-wraper {
  flex: 1 1 auto;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/libs/air-date-picker/src/datepicker.scss","webpack://./src/libs/air-date-picker/src/_objects.scss","webpack://./src/templatemanager/templates/dateRange/dateRange.scss","webpack://./src/libs/air-date-picker/src/datepickerBody.scss","webpack://./src/libs/air-date-picker/src/datepickerVars.scss","webpack://./src/templatemanager/base/animations.scss","webpack://./src/templatemanager/base/variables.scss","webpack://./src/libs/air-date-picker/src/datepickerButtons.scss","webpack://./src/libs/air-date-picker/src/datepickerNav.scss","webpack://./src/libs/air-date-picker/src/datepickerCell.scss","webpack://./src/libs/air-date-picker/src/datepickerTime.scss"],"names":[],"mappings":"AAAA;;sDAAA;ACAA;EACE,mCAAA;ACIF;ADGI;EACE,mCAAA;ACDN;ADKE;EACE,WAAA;EACA,4DAAA;ACHJ;ADII;EACE,oEAAA;ACFN;ADME;EACE,2DAAA;EACA,uBAAA;ACJJ;ADMI;EACE,2DAAA;ACJN;ADMI;EACE,6CAAA;ACJN;ADSE;EACE,gBAAA;EACA,YAAA;ACPJ;;AC7BA;;sDAAA;AAIA;EACE,yEAAA;AD+BF;AC7BE;EACE,aAAA;AD+BJ;;AC1BA;sDAAA;AAGA;EACE,aAAA;EACA,2DAAA;EACA,kBAAA;AD4BF;;ACzBA;EACE,gCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AD4BF;AC3BE;EACE,eAAA;AD6BJ;AC3BI;EACE,sCAAA;AD6BN;;ACxBA;sDAAA;AAGA;EACE,aAAA;AD0BF;ACzBE;EACE,2DAAA;EACA,0CAAA;AD2BJ;ACxBE;EACE,qCAAA;EACA,4CAAA;EACA,eAAA;AD0BJ;ACvBE;EACE,qCAAA;EACA,2CAAA;EACA,eAAA;ADyBJ;;AExFA;;sDAAA;ACEA;EACI;IACE,gBAAA;EH4FJ;EG1FE;IACI,iBAAA;EH4FN;AACF;AGzFA;EACI;IAAyB,wBAAA;EH4F3B;EG3FE;IAAK,4BAAA;EH8FP;EG7FE;IAAK,4BAAA;EHgGP;AACF;AG/FA;EACI;IACE,UAAA;IACA,qBAAA;EHiGJ;EG/FE;IACE,UAAA;IACA,mBAAA;EHiGJ;EG/FE;IAAM,2BAAA;EHkGR;EGjGE;IAAO,gCAAA;EHoGT;AACF;AGlGA;EACI;IACE,UAAA;IACA,2BAAA,EAAA,gCAAA;EHoGJ;EGlGE;IACI,UAAA;IACA,4BAAA,EAAA,iDAAA;EHoGN;EGlGE;IACE,UAAA;IACA,uBAAA,EAAA,iDAAA;EHoGJ;AACF;AGjGA;EACI;IACI,UAAA;IACA,2BAAA,EAAA,gCAAA;EHmGN;EGjGE;IACI,UAAA;IACA,uBAAA,EAAA,iDAAA;EHmGN;AACF;AG7FA;EACI;IACE,UAAA;IACA,mBAAA;IACA,gBAAA;EH+FJ;EG7FE;IACE,gBAAA;EH+FJ;EG7FE;IACI,UAAA;IACA,mBAAA;IACA,iBAAA;EH+FN;AACF;AG7FA;EACI;IACE,UAAA;IACA,gBAAA;EH+FJ;EG7FE;IACE,UAAA;IACA,gBAAA;EH+FJ;EG7FE;IACE,2BAAA;EH+FJ;EG7FE;IACE,2BAAA;EH+FJ;EG7FE;IACE,eAAA;IACA,iBAAA;EH+FJ;AACF;AGxFA;EACI;IACE,UAAA;IACA,0BAAA;EH0FJ;EGxFE;IACE,UAAA;IACA,0BAAA;EH0FJ;EGxFE;IACE,UAAA;IACA,wBAAA;EH0FJ;AACF;AGnFA;EACE;IACE,UAAA;IACA,2BAAA;EHqFF;EGnFA;IACE,UAAA;IACA,wBAAA;EHqFF;AACF;AGhFA;EACI;IACE,UAAA;IACA,4BAAA;EHkFJ;EGhFE;IACI,YAAA;IACA,0BAAA;EHkFN;EGhFE;IACE,UAAA;IACA,uBAAA;EHkFJ;AACF;AG3EA;EACI;IACE,UAAA;IACA,2BAAA,EAAA,gCAAA;EH6EJ;EG3EE;IACI,YAAA;IACA,2BAAA,EAAA,iDAAA;EH6EN;EG3EE;IACE,UAAA;IACA,uBAAA,EAAA,iDAAA;EH6EJ;AACF;AGxEA;EACI;IACI,qBAAA;IACA,gJAAA;EH0EN;EGpEE;IACI,eAAA;EHsEN;EGnEE;IACI,qBAAA;IACA,6IAAA;EHqEN;AACF;AG/DA;EACI;IACI,qBAAA;EHiEN;EG/DE;IACI,gJAAA;EHiEN;EG3DI;IACE,eAAA;EH6DN;EG3DI;IACE,8IAAA;IAKA,qBAAA;EHyDN;EGvDE;IACI,qBAAA;EHyDN;AACF;AGlDA;EACI;IACE,yBAAA;EHoDJ;EGlDE;IACI,UAAA;IACA,2BAAA;IACA,aAAA;EHoDN;AACF;AGlDA;EACI;IACE,UAAA;IACA,2BAAA;EHoDJ;EGlDE;IACI,UAAA;IACA,4BAAA;EHoDN;EGlDE;IACE,UAAA;IACA,uBAAA;EHoDJ;AACF;AG5CA;EACE,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AH8CF;;AG3CA;EACE;IACE,UAAA;IACA,yCAAA;IACA,iCAAA;EH8CF;EG5CA;IACE,UAAA;EH8CF;AACF;AG3CA;EACE;IACE,UAAA;IACA,yCAAA;IACA,iCAAA;EH6CF;EG3CA;IACE,UAAA;EH6CF;AACF;AGtCA;EACE,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AHwCF;;AGrCA;EACE;IACE,mCAAA;IACA,2BAAA;IACA,mBAAA;EHwCF;EGtCA;IACE,gCAAA;IACA,0BAAA;EHwCF;EGtCA;IACE,gCAAA;IACA,wBAAA;EHwCF;AACF;AGrCA;EACE;IACE,mCAAA;IACA,2BAAA;IACA,mBAAA;EHuCF;EGrCA;IACE,gCAAA;IACA,0BAAA;EHuCF;EGrCA;IACE,gCAAA;IACA,wBAAA;EHuCF;AACF;AGpCA;EACC,4EAAA;EACQ,oEAAA;AHsCT;;AGnCA;EACC,+EAAA;EACQ,uEAAA;AHsCT;;AGnCC;EACC;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;EHsCF;EGpCA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;EHsCF;AACF;AGnCA;EACE;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;EHqCF;EGnCA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;EHqCF;AACF;AGjCA;EACA;IACE,6BAAA;IACQ,qBAAA;IACR,mCAAA;IACQ,2BAAA;EHmCR;EGjCF;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;EHmCR;AACF;AGhCA;EACE;IACE,6BAAA;IACQ,qBAAA;IACR,mCAAA;IACQ,2BAAA;EHkCV;EGhCA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;EHkCV;AACF;AG5BA;EACE;IAAK,+BAAA;EH+BL;EG9BA;IAAO,iCAAA;EHiCP;AACF;AG/BA;EACE;IAAK,uBAAA;EHkCL;EGjCA;IAAO,yBAAA;EHoCP;AACF;AG/BA;EACE,gCAAA;EACA,wBAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;AHiCF;;AG9BA;EACE;IACE,gCAAA;IACA,wBAAA;IACA,6CAAA;IACA,qCAAA;IACA,UAAA;EHiCF;EG9BA;IACE,gCAAA;IACA,wBAAA;IACA,uBAAA;IACA,eAAA;IACA,UAAA;EHgCF;AACF;AG7BA;EACE;IACE,gCAAA;IACA,wBAAA;IACA,6CAAA;IACA,qCAAA;IACA,UAAA;EH+BF;EG5BA;IACE,gCAAA;IACA,wBAAA;IACA,uBAAA;IACA,eAAA;IACA,UAAA;EH8BF;AACF;AGxBA;EACE;IACI,gDAAA;EH0BJ;EGxBA;IACI,YAAA;EH0BJ;AACF;AGrBA;EACE,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;AHuBF;;AGpBA;EACE;IACE,UAAA;EHuBF;EGpBA;IACE,UAAA;EHsBF;AACF;AGnBA;EACE;IACE,UAAA;EHqBF;EGlBA;IACE,UAAA;EHoBF;AACF;AGdA;EACE,kCAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AHgBF;;AGbA;EAEE;IAKE,uEAAA;IACA,+DAAA;EHWF;EGRA;IACE,UAAA;IACA,4CAAA;IACA,oCAAA;EHUF;EGPA;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EHSF;EGNA;IACE,0CAAA;IACA,kCAAA;EHQF;EGLA;IACE,0CAAA;IACA,kCAAA;EHOF;EGJA;IACE,uCAAA;IACA,+BAAA;EHMF;AACF;AGHA;EAEE;IAKE,uEAAA;IACA,+DAAA;EHAF;EGGA;IACE,UAAA;IACA,4CAAA;IACA,oCAAA;EHDF;EGIA;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EHFF;EGKA;IACE,0CAAA;IACA,kCAAA;EHHF;EGMA;IACE,0CAAA;IACA,kCAAA;EHJF;EGOA;IACE,uCAAA;IACA,+BAAA;EHLF;AACF;AGUA;EACE,kCAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AHRF;;AGWA;EACE;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EHRF;EGWA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EHTF;AACF;AGYA;EACE;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EHVF;EGaA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EHXF;AACF;AGgBA;EACE,gCAAA;EACA,wBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AHdF;;AGiBA;EACE;IACE,UAAA;IACA,0CAAA;IACA,kCAAA;EHdF;EGiBA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EHfF;AACF;AGkBA;EACE;IACE,UAAA;IACA,0CAAA;IACA,kCAAA;EHhBF;EGmBA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EHjBF;AACF;AGsBA;EACE,+BAAA;EACA,uBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AHpBF;;AGuBA;EACE;IACE,UAAA;EHpBF;EGuBA;IACE,UAAA;EHrBF;AACF;AGwBA;EACE;IACE,UAAA;EHtBF;EGyBA;IACE,UAAA;EHvBF;AACF;AG0BA;EACI,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AHxBJ;;AG0BE;EACE;IACE,mCAAA;IACA,2BAAA;EHvBJ;EGyBE;IACE,gCAAA;IACA,wBAAA;EHvBJ;AACF;AIlrBA;EAGI,yEAAA;EACA,6EAAA;EACA,uEAAA;EACA,2EAAA;EAII,qEAAA;EACA,yEAAA;EACA,sEAAA;EACA,2EAAA;EAGA,0EAAA;EACA,8EAAA;EACA,8EAAA;EACA,kFAAA;EAEA,kEAAA;EACA,oFAAA;EACA,oCAAA;EACA,kFAAA;EACA,+FAAA;EACA,qFAAA;EACA,kGAAA;EAMA,kEAAA;EAGJ,wDAAA;EACA,2DAAA;EACA,mDAAA;EACA,qEAAA;EACA,sDAAA;EACA,2DAAA;EACA,2DAAA;EACA,iDAAA;EAGI,kEAAA;EACA,2EAAA;EACA,4EAAA;EACA,+CAAA;EAIA,gEAAA;EAIA,gDAAA;EACA,oDAAA;EACA,sDAAA;EAIA,uCAAA;EACA,qDAAA;EACA,8EAAA;EACA,oFAAA;EACA,kDAAA;EACA,0DAAA;EACA,yDAAA;EACA,2DAAA;EACA,+DAAA;EACA,4DAAA;EACA,oEAAA;EACA,gEAAA;EACA,yDAAA;EACA,iEAAA;EACA,2GAAA;EACA,gEAAA;EACA,4GAAA;EACA,oFAAA;EACA,yDAAA;EAIA,oEAAA;EACA,0DAAA;EACA,4JAAA;EACA,gEAAA;EACA,mEAAA;EACA,gFAAA;EACA,mFAAA;EACA,+EAAA;EACA,uDAAA;EAIA,kEAAA;EAIA,mDAAA;EACA,yEAAA;EACA,+DAAA;EACA,4FAAA;EACA,qGAAA;EACA,sEAAA;EACA,kFAAA;EACA,4EAAA;EACA,qEAAA;EACA,sEAAA;EACA,kEAAA;EACA,uEAAA;EACA,oFAAA;EACA,6EAAA;EACA,8EAAA;EACA,uQAAA;EACA,sQAAA;EACA,0FAAA;EACA,kFAAA;EAIA,oDAAA;EACA,uEAAA;EACA,6EAAA;EACA,uEAAA;EACA,kDAAA;EAIA,qEAAA;EAIA,kEAAA;EAIA,sDAAA;EACA,0EAAA;EACA,gFAAA;EACA,0EAAA;EACA,oDAAA;EACA,6CAAA;EAIA,kDAAA;EACA,sDAAA;EACA,2DAAA;EACA,mDAAA;EAIA,kEAAA;EACA,iEAAA;EAMA,2CAAA;EACA,mDAAA;EACA,gDAAA;EACA,qDAAA;EACA,2DAAA;EACA,4CAAA;EACA,sDAAA;EACA,kJAAA;EACA,mDAAA;EACA,uDAAA;EACA,wDAAA;EACA,kIAAA;EAIA,qDAAA;EACA,yDAAA;EACA,iDAAA;EACA,iDAAA;EACA,yCAAA;EACA,8CAAA;EACA,iDAAA;EACA,gDAAA;EACA,mDAAA;EACA,yDAAA;EACA,0DAAA;EACA,4DAAA;EAIA,6CAAA;EACA,oDAAA;EACA,+CAAA;EACA,mEAAA;EACA,0DAAA;EAGA,6CAAA;EACA,sDAAA;EACA,iDAAA;EACA,oDAAA;EAII,kDAAA;EACA,6CAAA;EACA,qCAAA;EACA,iEAAA;AJ+mBZ;;AIvkBA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,6CAAA;EACA,uDAAA;EACA,2CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AJ0kBJ;AIzkBI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AJ2kBR;AIzkBI;EACI,mDAAA;AJ2kBR;AIzkBI;EACI,YAAA;EACA,oBAAA;AJ2kBR;;AIxkBA;EACI,WAAA;EACA,iCAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AJ2kBJ;AI1kBI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AJ4kBR;AI1kBI;EACI,uCAAA;AJ4kBR;;AIxkBA;EACI,WAAA;EACA,kCAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AJ2kBJ;AIzkBQ;EACI,4BAAA;AJ2kBZ;AIxkBI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AJ0kBR;AIxkBI;EACI,kCAAA;AJ0kBR;;AIrkBI;EACI,kCAAA;EACA,eAAA;AJwkBR;AItkBI;EACI,oCAAA;AJwkBR;AItkBI;EACI,kCAAA;EACA,eAAA;AJwkBR;AItkBI;EACI,oCAAA;AJwkBR;AIrkBQ;EACI,kCAAA;EACA,eAAA;AJukBZ;AIpkBI;EACI,kCAAA;EACA,eAAA;AJskBR;;AEz7BA;EACE,4CAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA;;;;aAAA;EAMA,8BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,kDAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,qEAAA;EACA,kFAAA;EACA,0EAAA;EAEA,yCAAA;EACA,mDAAA;EACA,gDAAA;EACA,iDAAA;EACA,gCAAA;EACA,6BAAA;EACA,sCAAA;EACA,2DAAA;EAEA,2BAAA;EACA,iCAAA;EACA,wBAAA;EACA,kCAAA;EAEA,sBAAA;EACA,iDAAA;EACA,2BAAA;EACA,qDAAA;EAEA,kDAAA;EACA,yDAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;EAEA,wBAAA;EACA,+BAAA;EACA,0BAAA;EAEA,+BAAA;EACA,oEAAA;EACA,mEAAA;EACA,yEAAA;EACA,oEAAA;EACA,0EAAA;EAEA,sBAAA;EACA,wCAAA;EACA,uCAAA;EACA,iDAAA;EACA,mEAAA;EACA,qEAAA;EAEA,4BAAA;EACA,+BAAA;EACA,qCAAA;EACA,2BAAA;EACA,8BAAA;EACA,uDAAA;EAEA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,kCAAA;EACA,oCAAA;EACA,mCAAA;AFg7BF;;AE76BA;EACE,iDAAA;EACA,sCAAA;EACA,uCAAA;EACA,yBAAA;AFg7BF;;AK5gCA;;sDAAA;AAIA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;AL8gCF;;AK3gCA;EACE,oBAAA;EACA,2BAAA;EACA,2CAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,kCAAA;AL8gCF;AK5gCE;EACE,iCAAA;EACA,iDAAA;AL8gCJ;AK3gCE;EACE,iCAAA;EACA,iDAAA;EACA,aAAA;AL6gCJ;AK1gCE;EACE,kDAAA;AL4gCJ;AKzgCE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AL2gCJ;;AMnjCA;;sDAAA;AAIA;EACE,aAAA;EACA,8BAAA;EACA,sDAAA;EACA,iCAAA;EACA,2BAAA;EACA,uBAAA;ANqjCF;AMnjCE;EACE,aAAA;ANqjCJ;;AMljCA;;EAEE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;ANqjCF;;AMljCA;sDAAA;AAGA;EACE,iCAAA;EACA,uCAAA;EACA,iBAAA;ANojCF;AMljCE;EACE,6CAAA;ANojCJ;AMjjCE;EACE,8CAAA;ANmjCJ;AMhjCE;EACE,kBAAA;ANkjCJ;AM/iCE;EACE,WAAA;EACA,YAAA;ANijCJ;AM9iCE;EACE,UAAA;EACA,kCAAA;EACA,iBAAA;ANgjCJ;;AM5iCA;sDAAA;AAGA;EACE,uCAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AN8iCF;AM5iCE;EACE,kBAAA;EACA,uBAAA;EACA,kBAAA;AN8iCJ;AM3iCE;EACE,6CAAA;AN6iCJ;AM1iCE;EACE,8CAAA;AN4iCJ;AMziCE;EACE,eAAA;EACA,gBAAA;AN2iCJ;;AD/nCA;EACE,mCAAA;ACkoCF;AD3nCI;EACE,mCAAA;AC6nCN;ADznCE;EACE,WAAA;EACA,4DAAA;AC2nCJ;AD1nCI;EACE,oEAAA;AC4nCN;ADxnCE;EACE,2DAAA;EACA,uBAAA;AC0nCJ;ADxnCI;EACE,2DAAA;AC0nCN;ADxnCI;EACE,6CAAA;AC0nCN;ADrnCE;EACE,gBAAA;EACA,YAAA;ACunCJ;;AOzpCA;;sDAAA;AAIA;EACE,4CAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AP2pCF;AO1pCE;EACE,kDAAA;AP4pCJ;AOzpCE;EACE,oCAAA;EACA,6CAAA;AP2pCJ;AO1pCI;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AP4pCN;AO1pCI;EACE,uBAAA;AP4pCN;AOzpCI;EACE,oCAAA;AP2pCN;AOvpCE;EACE,eAAA;EACA,gCAAA;APypCJ;AOvpCI;EACE,gCAAA;APypCN;AOtpCI;EACE,yCAAA;EACA,6CAAA;APwpCN;AOppCM;EACE,gCAAA;APspCR;AOjpCE;EACE,qDAAA;APmpCJ;AOjpCI;EACE,2DAAA;APmpCN;AO/oCE;EACE,2DAAA;EACA,4CAAA;APipCJ;AO/oCE;EACE,2DAAA;EACA,4CAAA;APipCJ;AO9oCE;EACE,4CAAA;APgpCJ;AO7oCE;EACE,8BAAA;EACA,YAAA;EACA,qDAAA;AP+oCJ;AO7oCI;EACE,8BAAA;EACA,qDAAA;AP+oCN;AO5oCI;EACE,2DAAA;AP8oCN;AO3oCE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AP6oCJ;AO3oCE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AP6oCJ;;AOxoCA;sDAAA;AASA;sDAAA;AC7HA;;sDAAA;AAuDA;EACE,aAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,YAAA;EACA,eAAA;AR8sCF;AQ5sCE;EACE,gBAAA;AR8sCJ;;AQvsCA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;AR0sCF;;AQvsCA;EACE,iBAAA;EACA,cAAA;AR0sCF;;AQvsCA;;EAEE,cAAA;EACA,eAAA;EACA,qEAAA;EACA,kBAAA;EACA,UAAA;AR0sCF;AQxsCE;;EACE,WAAA;EACA,6CAAA;EACA,uCAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AR2sCJ;AQvsCI;;EACE,UAAA;AR0sCN;;AQrsCA;EACE,yBAAA;EACA,oBAAA;EACA,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;ARwsCF;;AQrsCA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,oJACE;ARusCJ;AQpsCE;EACE,kBAAA;ARssCJ;AQnsCE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;ARqsCJ;AQnsCI;EACE,wBAAA;ARqsCN;AQlsCI;EACE,aAAA;ARosCN;AQr0CE;EAsIM,+CAAA;ARksCR;AQp0CE;EAkIM,+CAAA;ARqsCR;AQn0CE;EA8HM,+CAAA;ARwsCR;AQpsCI;EACE,aAAA;ARssCN;AQj1CE;EA8IM,qDAAA;EACA,uDAAA;ARssCR;AQj1CE;EA0IM,qDAAA;EACA,uDAAA;AR0sCR;AQj1CE;EAsIM,qDAAA;EACA,uDAAA;AR8sCR;AQ71CE;EAcA,sBAAA;EACA,YAhCe;EAiCf,WAjCe;EAkCf,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EAEA,qDAAA;ARi1CF;AQn2CE;EAUA,sBAAA;EACA,YAhCe;EAiCf,WAjCe;EAkCf,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EAEA,qDAAA;AR21CF;AQz2CE;EAMA,sBAAA;EACA,YAhCe;EAiCf,WAjCe;EAkCf,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EAEA,qDAAA;ARq2CF;AQjuCI;EACE,qDAAA;ARmuCN;AQ54CE;EAwCA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;ARu2CF;AQ/4CE;EAoCA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AR82CF;AQl5CE;EAgCA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;ARq3CF;AQ/uCI;EACE,uBAAA;ARivCN;AQ5uCI;EACE,uBAAA;AR8uCN;AFp6CA;EACE,kBAAA;EACA,8FAAA;EACA,uCAAA;EACA,yCAAA;EACA,uCAAA;EACA,uBAAA;EACA,aAAA;EACA,0BAAA;EACA,0CAAA;EACA,0CAAA;EACA,+CAAA;EACA,+BAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kJACQ;EAER,2BAAA;AEo6CF;AFl6CE;EACE,UAAA;AEo6CJ;AFj6CE;EACE,8DAAA;AEm6CJ;AFj6CE;EACE,mDAAA;AEm6CJ;AFj6CE;EACE,mDAAA;AEm6CJ;AFj6CE;EACE,8DAAA;AEm6CJ;AF/5CI;EACE,0BAAA;EACA,UAAA;AEi6CN;AF95CI;EACE,gBAAA;AEg6CN;AF55CE;EACE,8FAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AE85CJ;AF55CI;EACE,aAAA;AE85CN;AF15CE;EACE,4CAAA;EACA,wDAAA;EACA,4DAAA;EACA,0DAAA;EACA,8CAAA;EACA,mDAAA;EAEA,eAAA;EACA,8BAAA;AE25CJ;AFz5CI;EACE,wCAAA;AE25CN;AFx5CI;EACE,aAAA;AE05CN;AFv5CI;EACE,qEAAA;AEy5CN;AFr5CM;EACE,gCAAA;AEu5CR;AFl5CE;EACE,gBAAA;AEo5CJ;;AFh5CA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;AEm5CF;;AFh5CA;EACE,sDAAA;EAEA,kBAAA;EACA,8BAAA;EACA,+BAAA;EACA,WAAA;AEk5CF;AFh5CE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;EACA,sDAAA;EACA,wDAAA;EACA,8BAAA;EACA,+BAAA;EACA,sBAAA;AEk5CJ;AF54CE;EAIE,gDAAA;AE24CJ;AF14CI;EACE,yBAAA;AE44CN;AFx4CE;EAIE,kDAAA;AEu4CJ;AFt4CI;EACE,yBAAA;AEw4CN;AFp4CE;EAIE,mDAAA;AEm4CJ;AFl4CI;EACE,yBAAA;AEo4CN;AFh4CE;EAIE,iDAAA;AE+3CJ;AF93CI;EACE,wBAAA;AEg4CN;AFz3CE;EACE,+BAAA;AE23CJ;AFz3CE;EACE,gCAAA;AE23CJ;AFz3CE;EACE,6CAAA;AE23CJ;AFx3CE;EACE,8BAAA;AE03CJ;AFx3CE;EACE,iCAAA;AE03CJ;AFx3CE;EACE,4CAAA;AE03CJ;;AFr3CA;EACE,cAAA;AEw3CF;;AFr3CA;EACE,uBAAA;EACA,2BAAA;EACA,eAAA;AEw3CF;AFt3CE;EACE,aAAA;AEw3CJ;;AFp3CA;EACE,qBAAA;AEu3CF;;AFp3CA;EACE,kBAAA;AEu3CF;;AFp3CA;;EAEE,2BAAA;EACA,mDAAA;AEu3CF;;AFn3CA;sDAAA;AAGA;EACE,eAAA;EACA,+CAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,2HACQ;EAIR,4IACQ;EAIR,mCAAA;AE62CF;AF12CE;EACE,UAAA;EACA,WAAA;EACA,YAAA;EAEA,kHACQ;AE02CZ;;AA7mDA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAgnDJ;AA/mDI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AAinDR;AAhnDQ;EACI,WAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAknDZ;AAhnDQ;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAknDZ;AAhnDgB;EACI,kCAAA;AAknDpB;AA7mDI;EACI,cAAA;EACA,cAAA;AA+mDR","sourcesContent":["/* -------------------------------------------------\n    Datepicker\n   ------------------------------------------------- */\n@import \"./objects\";\n@import \"./datepickerBody.scss\";\n@import \"./datepickerVars.scss\";\n@import \"./datepickerButtons.scss\";\n@import \"./datepickerNav.scss\";\n@import \"./datepickerCell.scss\";\n@import \"./datepickerTime.scss\";\n\n.air-datepicker {\n  border-radius: 8px;\n  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);\n  background: var(--adp-background-color);\n  border: 1px solid var(--adp-border-color);\n  border-radius: var(--adp-border-radius);\n  box-sizing: content-box;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(4, max-content);\n  grid-template-areas: var(--adp-grid-areas);\n  font-family: var(--adp-font-family), sans-serif;\n  font-size: var(--adp-font-size);\n  color: var(--adp-color);\n  width: var(--adp-width);\n  position: absolute;\n  transition:\n          opacity var(--adp-transition-duration) var(--adp-transition-ease),\n          transform var(--adp-transition-duration) var(--adp-transition-ease);\n  z-index: var(--adp-z-index);\n\n  &:not(.-custom-position-) {\n    opacity: 0;\n  }\n\n  &.-from-top- {\n    transform: translateY(calc(var(--adp-transition-offset) * -1));\n  }\n  &.-from-right- {\n    transform: translateX(var(--adp-transition-offset));\n  }\n  &.-from-bottom- {\n    transform: translateY(var(--adp-transition-offset));\n  }\n  &.-from-left- {\n    transform: translateX(calc(var(--adp-transition-offset) * -1));\n  }\n\n  &.-active- {\n    &:not(.-custom-position-) {\n      transform: translate(0, 0);\n      opacity: 1;\n    }\n\n    &.-custom-position- {\n      transition: none\n    }\n  }\n\n  &.-inline- {\n    box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);\n    position: static;\n    left: auto;\n    right: auto;\n    opacity: 1;\n    transform: none;\n\n    .air-datepicker--pointer {\n      display: none;\n    }\n  }\n\n  &.-is-mobile- {\n    --adp-font-size: var(--adp-mobile-font-size);\n    --adp-day-cell-height: var(--adp-mobile-day-cell-height);\n    --adp-month-cell-height: var(--adp-mobile-month-cell-height);\n    --adp-year-cell-height: var(--adp-mobile-year-cell-height);\n    --adp-nav-height: var(--adp-mobile-nav-height);\n    --adp-nav-action-size: var(--adp-mobile-nav-height);\n\n    position: fixed;\n    width: var(--adp-mobile-width);\n\n    * {\n      -webkit-tap-highlight-color: transparent;\n    }\n\n    .air-datepicker--pointer {\n      display: none;\n    }\n\n    &:not(.-custom-position-) {\n      transform: translate(-50%, calc(-50% + var(--adp-transition-offset)));\n    }\n\n    &.-active- {\n      &:not(.-custom-position-) {\n        transform: translate(-50%, -50%);\n      }\n    }\n  }\n\n  &.-custom-position- {\n    transition: none;\n  }\n}\n\n.air-datepicker-global-container {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.air-datepicker--pointer {\n  --pointer-half-size: calc(var(--adp-pointer-size) / 2);\n\n  position: absolute;\n  width: var(--adp-pointer-size);\n  height: var(--adp-pointer-size);\n  z-index: -1;\n\n  &:after {\n    content: '';\n    position: absolute;\n    background: #fff;\n    border-top: 1px solid var(--adp-border-color-inline);\n    border-right: 1px solid var(--adp-border-color-inline);\n    border-top-right-radius: var(--adp-poiner-border-radius);\n    width: var(--adp-pointer-size);\n    height: var(--adp-pointer-size);\n    box-sizing: border-box;\n  }\n\n  //  Main axis\n  // -------------------------\n\n  .-top-left- &,\n  .-top-center- &,\n  .-top-right- &,\n  [data-popper-placement^='top'] & {\n    top: calc(100% - var(--pointer-half-size) + 1px);\n    &:after {\n      transform: rotate(135deg);\n    }\n  }\n\n  .-right-top- &,\n  .-right-center- &,\n  .-right-bottom- &,\n  [data-popper-placement^='right'] & {\n    right: calc(100% - var(--pointer-half-size) + 1px);\n    &:after {\n      transform: rotate(225deg);\n    }\n  }\n\n  .-bottom-left- &,\n  .-bottom-center- &,\n  .-bottom-right- &,\n  [data-popper-placement^='bottom'] & {\n    bottom: calc(100% - var(--pointer-half-size) + 1px);\n    &:after {\n      transform: rotate(315deg);\n    }\n  }\n\n  .-left-top- &,\n  .-left-center- &,\n  .-left-bottom- &,\n  [data-popper-placement^='left'] & {\n    left: calc(100% - var(--pointer-half-size) + 1px);\n    &:after {\n      transform: rotate(45deg);\n    }\n  }\n\n  //  Secondary axis\n  // -------------------------\n\n  .-top-left- &, .-bottom-left- & {\n    left: var(--adp-pointer-offset);\n  }\n  .-top-right- &, .-bottom-right- & {\n    right: var(--adp-pointer-offset);\n  }\n  .-top-center- &, .-bottom-center- & {\n    left: calc(50% - var(--adp-pointer-size) / 2);\n  }\n\n  .-left-top- &, .-right-top- & {\n    top: var(--adp-pointer-offset);\n  }\n  .-left-bottom- &, .-right-bottom- & {\n    bottom: var(--adp-pointer-offset);\n  }\n  .-left-center- &, .-right-center- & {\n    top: calc(50% - var(--adp-pointer-size) / 2);\n  }\n}\n\n\n.air-datepicker--navigation {\n  grid-area: nav;\n}\n\n.air-datepicker--content {\n  box-sizing: content-box;\n  padding: var(--adp-padding);\n  grid-area: body;\n\n  .-only-timepicker- & {\n    display: none;\n  }\n}\n\n.air-datepicker--time {\n  grid-area: timepicker;\n}\n\n.air-datepicker--buttons {\n  grid-area: buttons;\n}\n\n.air-datepicker--buttons,\n.air-datepicker--time {\n  padding: var(--adp-padding);\n  border-top: 1px solid var(--adp-border-color-inner);\n}\n\n\n/*  Overlay\n   ------------------------------------------------- */\n\n.air-datepicker-overlay {\n  position: fixed;\n  background: var(--adp-overlay-background-color);\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 0;\n  opacity: 0;\n  transition:\n          opacity var(--adp-overlay-transition-duration) var(--adp-overlay-transition-ease),\n          left 0s,\n          height 0s,\n          width 0s;\n  transition-delay:\n          0s,\n          var(--adp-overlay-transition-duration),\n          var(--adp-overlay-transition-duration),\n          var(--adp-overlay-transition-duration);\n  z-index: var(--adp-overlay-z-index);\n\n\n  &.-active- {\n    opacity: 1;\n    width: 100%;\n    height: 100%;\n\n    transition:\n            opacity var(--adp-overlay-transition-duration) var(--adp-overlay-transition-ease),\n            height 0s,\n            width 0s;\n  }\n}\n","%otherMonth {\n  color: var(--adp-color-other-month);\n\n  &:hover {\n    // color: var(--adp-cell-background-color-in-range);\n  }\n\n  &.-disabled- {\n    &.-focus- {\n      color: var(--adp-color-other-month);\n    }\n  }\n\n  &.-selected- {\n    color: #fff;\n    background: var(--adp-background-color-selected-other-month);\n    &.-focus- {\n      background: var(--adp-background-color-selected-other-month-focused);\n    }\n  }\n\n  &.-in-range- {\n    background-color: var(--adp-cell-background-color-in-range);\n    color: var(--adp-color);\n\n    &.-focus- {\n      background-color: var(--adp-cell-background-color-in-range);\n    }\n    &.-disabled- {\n      background-color: var(--adp-background-color);\n    }\n  }\n\n\n  &:empty {\n    background: none;\n    border: none;\n  }\n}\n","@import \"../../../libs/air-date-picker/src/datepicker.scss\";\n\n.menu-wrapper-data-actions{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    .actions-slider-header-menu{\n        display: flex;\n        align-items: center;\n        padding: 14px 15px;\n        gap: 10px;\n        flex-shrink: 0;\n        h1{\n            width: 100%;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 700;\n            line-height: normal;\n        }\n        .menu-close{\n            width: 16px;\n            height: 16px;\n            border: 0;\n            background: transparent;\n            padding: 0;\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            svg{\n                path{\n                    fill: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n    }\n    .iner-data-scroll-wraper{\n        flex: 1 1 auto;\n        overflow: auto;\n    }\n}","/* -------------------------------------------------\n    Datepicker body\n   ------------------------------------------------- */\n\n.air-datepicker-body {\n  transition: all var(--adp-transition-duration) var(--adp-transition-ease);\n\n  &.-hidden- {\n    display: none;\n  }\n}\n\n\n/*  Day names\n   ------------------------------------------------- */\n\n.air-datepicker-body--day-names {\n  display: grid;\n  grid-template-columns: repeat(7, var(--adp-day-cell-width));\n  margin: 0 0 10px 0;\n}\n\n.air-datepicker-body--day-name {\n  color: var(--adp-day-name-color);\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  text-align: center;\n  text-transform: capitalize;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  &.-clickable- {\n    cursor: pointer;\n\n    &:hover {\n      color: var(--adp-day-name-color-hover);\n    }\n  }\n}\n\n/*  Cells container\n   ------------------------------------------------- */\n\n.air-datepicker-body--cells {\n  display: grid;\n  &.-days- {\n    grid-template-columns: repeat(7, var(--adp-day-cell-width));\n    grid-auto-rows: var(--adp-day-cell-height);\n  }\n\n  &.-months- {\n    grid-template-columns: repeat(4, 1fr);\n    grid-auto-rows: var(--adp-month-cell-height);\n    padding: 0 10px;\n  }\n\n  &.-years- {\n    grid-template-columns: repeat(4, 1fr);\n    grid-auto-rows: var(--adp-year-cell-height);\n    padding: 0 10px;\n  }\n}\n","/* -------------------------------------------------\n    Datepicker vars\n   ------------------------------------------------- */\n@import \"../../../templatemanager/base/variables.scss\";\n.air-datepicker {\n  --adp-font-family: var(--global-font-family);\n  --adp-font-size: 14px;\n  --adp-width: 100%; // Day cell width will be equal to 34px\n  --adp-z-index: 100;\n  --adp-padding: 4px;\n  --adp-grid-areas:\n    'nav'\n    'body'\n    'timepicker'\n    'buttons';\n\n  --adp-transition-duration: .3s;\n  --adp-transition-ease: ease-out;\n  --adp-transition-offset: 8px;\n\n  --adp-background-color: var(--sdk-global-white-bg);\n  --adp-background-color-hover: var(--sdk-gloabl-bg-secondary);\n  --adp-background-color-active: var(--sdk-gloabl-bg-secondary);\n  --adp-background-color-in-range: var(--sdk-gloabl-text-color);\n  --adp-background-color-in-range-focused: var(--sdk-gloabl-text-color);\n  --adp-background-color-selected-other-month-focused: var(--sdk-global-theme-color);\n  --adp-background-color-selected-other-month: var(--sdk-global-theme-color);\n\n  --adp-color: var(--sdk-gloabl-text-color);\n  --adp-color-secondary: var(--sdk-gloabl-text-color);\n  --adp-accent-color: var(--sdk-gloabl-text-color);\n  --adp-color-current-date: var(--adp-accent-color);\n  --adp-color-other-month: #9AA4B2;\n  --adp-color-disabled: #aeaeae;\n  --adp-color-disabled-in-range: #939393;\n  --adp-color-other-month-hover: var(--sdk-gloabl-text-color);\n\n  --adp-border-color: #E4E5E7;\n  --adp-border-color-inner: #E4E5E7;\n  --adp-border-radius: 8px;\n  --adp-border-color-inline: #E4E5E7;\n\n  --adp-nav-height: 36px;\n  --adp-nav-arrow-color: var(--adp-color-secondary);\n  --adp-nav-action-size: 36px;\n  --adp-nav-color-secondary: var(--adp-color-secondary);\n\n  --adp-day-name-color: var(--sdk-gloabl-text-color);\n  --adp-day-name-color-hover: var(--sdk-global-theme-color);\n\n  --adp-day-cell-width: 1fr;\n  --adp-day-cell-height: 42px;\n  --adp-month-cell-height: 40px;\n  --adp-year-cell-height: 56px;\n\n  --adp-pointer-size: 10px;\n  --adp-poiner-border-radius: 2px;\n  --adp-pointer-offset: 14px;\n\n  --adp-cell-border-radius: 100px;\n  --adp-cell-background-color-hover: var(--adp-background-color-hover);\n  --adp-cell-background-color-selected: var(--sdk-global-theme-color);\n  --adp-cell-background-color-selected-hover: var(--sdk-global-theme-color);\n  --adp-cell-background-color-in-range: var(--sdk-gloabl-border-color);\n  --adp-cell-background-color-in-range-hover: var(--sdk-gloabl-border-color);\n\n  --adp-btn-height: 32px;\n  --adp-btn-color: var(--adp-accent-color);\n  --adp-btn-color-hover: var(--adp-color);\n  --adp-btn-border-radius: var(--adp-border-radius);\n  --adp-btn-background-color-hover: var(--adp-background-color-hover);\n  --adp-btn-background-color-active: var(--adp-background-color-active);\n\n  --adp-time-track-height: 1px;\n  --adp-time-track-color: #dedede;\n  --adp-time-track-color-hover: #b1b1b1;\n  --adp-time-thumb-size: 12px;\n  --adp-time-padding-inner: 10px;\n  --adp-time-day-period-color: var(--adp-color-secondary);\n\n  --adp-mobile-font-size: 16px;\n  --adp-mobile-nav-height: 40px;\n  --adp-mobile-width: 320px;\n  --adp-mobile-day-cell-height: 38px;\n  --adp-mobile-month-cell-height: 48px;\n  --adp-mobile-year-cell-height: 64px;\n}\n\n.air-datepicker-overlay {\n  --adp-overlay-background-color: rgba(0, 0, 0, .3);\n  --adp-overlay-transition-duration: .3s;\n  --adp-overlay-transition-ease: ease-out;\n  --adp-overlay-z-index: 99;\n}\n","// Avatar animations\n\n@keyframes remove-hidden {\n    0% {\n      overflow: hidden;\n    }\n    100% { \n        overflow: inherit; \n    }\n}\n\n@keyframes bounce2 {\n    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}\n    40% {transform: translateY(-30px);}\n    60% {transform: translateY(-15px);}\n}\n@keyframes bounce-in-avatar {\n    0% {\n      opacity: 0;\n      transform: scale(.3);\n    }\n    50% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    70% { transform:translateY(20px)}\n    100% { transform: scale(1) translate(0);}\n}\n\n@keyframes avatarBubbleAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(10px); /* Move the elements 100% down */\n    }\n    80% {\n        opacity: 1;\n        transform: translateY(-10px); /* Move the elements to their original position */\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n@keyframes slide-up {\n    0% {\n        opacity: 0;\n        transform: translateY(100%); /* Move the elements 100% down */\n    }\n    100% {\n        opacity: 1;\n        transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n// End Avatar animations\n\n// Chat open animations\n@keyframes quick {\n    0% {\n      opacity: 0;\n      transform: scale(0);\n      overflow: hidden;\n    }\n    90%, 50%{\n      overflow: hidden;\n    }\n    100% { \n        opacity: 1;\n        transform: scale(1);\n        overflow: inherit;\n    }\n}\n@keyframes bounce-in {\n    0% {\n      opacity: 0;\n      overflow: hidden;\n    }\n    40% {\n      opacity: 1;\n      overflow: hidden;\n    }\n    60% { \n      transform:translate(-10px)\n    }\n    80% { \n      transform:translate(-15px)\n    }\n    100% { \n      transform: none;\n      overflow: inherit;\n    }\n}\n\n// End\n\n// Bubble animations\n\n@keyframes bubbleAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n    20% {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0%);\n    }\n}\n\n// End\n\n// Voice show animation\n\n@keyframes voiceShowAnim {\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translate(0%);\n  }\n}\n\n// Left to right template animations\n\n@keyframes left-to-right-slide-anim {\n    0% {\n      opacity: 0;\n      transform: translateX(-100%);\n    }\n    80% {\n        opacity: 0.5;\n        transform: translateX(0px);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0);\n    }\n}\n\n// End\n\n// Right to Left template animations\n\n@keyframes right-to-left-slide-anim {\n    0% {\n      opacity: 0;\n      transform: translateX(100%); /* Move the elements 100% down */\n    }\n    80% {\n        opacity: 0.5;\n        transform: translateX(10px); /* Move the elements to their original position */\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n// Voice recording animations\n\n@keyframes recording {\n    from {\n        transform: scale( 1.1 );\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 1px rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 5px rgba(#4B4EDE, 0.2);\n    }\n\n    50% {\n        transform: none;\n    }\n\n    to {\n        transform: scale( 1.1 );\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 6px rgba(#4B4EDE, 0),\n          0 0 0 10px rgba(#4B4EDE, 0);\n    }\n}\n\n@keyframes voiceAnim {\n    from {\n        transform: scale( 1.1 );\n    }\n    0% {\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 1px rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 5px rgba(#4B4EDE, 0.2);\n        // transform: scale(1.1);\n      }\n      50% {\n        transform: none;\n    }\n      100% {\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 4px rgba(#4B4EDE, 0.2),\n          0 0 0 20px rgba(#4B4EDE, 0),\n          0 0 0 30px rgba(#4B4EDE, 0);\n        // transform: scale(0.9);\n        transform: scale( 1.1 );\n    }\n    to {\n        transform: scale( 1.1 );\n    }\n}\n\n// End\n\n// Bottom slider open close animations\n\n@keyframes closeBottomToTopAnim {\n    0% {\n      transform: translateY(0%);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(100%);\n        display: none;\n    }\n}   \n@keyframes slideBottomToTopAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(100%);\n    }\n    80% {\n        opacity: 1;\n        transform: translateY(-10px);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0);\n    }\n}   \n\n// End\n\n\n// Zoom Animations\n\n.zoomIn {\n  -webkit-animation-name: zoomIn;\n  animation-name: zoomIn;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(.3, .3, .3);\n    transform: scale3d(.3, .3, .3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(.3, .3, .3);\n    transform: scale3d(.3, .3, .3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n// End\n\n// Slide Animations\n\n.slideInRight {\n  -webkit-animation-name: slideInRight;\n  animation-name: slideInRight;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes slideInRight {\n  0% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: visible;\n  }\n  80% {\n    -webkit-transform: translateX(0);\n    transform: translateX(2px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInRight {\n  0% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: visible;\n  }\n  80% {\n    -webkit-transform: translateX(0);\n    transform: translateX(2px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n.scale-up-br {\n\t-webkit-animation: scale-up-br 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n\t        animation: scale-up-br 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n}\n\n.scale-out-br {\n\t-webkit-animation: scale-out-br 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n\t        animation: scale-out-br 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n}\n\n @-webkit-keyframes scale-out-br {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n\n@keyframes scale-out-br {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n\n\n@-webkit-keyframes scale-up-br {\n0% {\n  -webkit-transform: scale(0.5);\n          transform: scale(0.5);\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n100% {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n}\n\n@keyframes scale-up-br {\n  0% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n  }\n}\n\n\n/// Loader Animations\n\n@-webkit-keyframes spinLoader {\n  0% { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes spinLoader {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n// Rotate Icon close\n\n.rotateIn {\n  -webkit-animation-name: rotateIn;\n  animation-name: rotateIn;\n  -webkit-animation-duration: 0.5s;\n  animation-duration: 0.5s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, -200deg);\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1;\n  }\n}\n\n@keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, -200deg);\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1;\n  }\n}\n\n\n// Typing Indicator\n  \n@keyframes dot-flashing {\n  0% {\n      background-color: var(--sdk-gloabl-bg-secondary);\n  }\n  50%, 100% {\n      opacity: 0.5;\n  }\n}\n\n// Fade In\n\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  display: flex;\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n\n\n\n.bounceInUp {\n  -webkit-animation-name: bounceInUp;\n  animation-name: bounceInUp;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes bounceInUp {\n\n  0%,\n  60%,\n  75%,\n  90%,\n  100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes bounceInUp {\n\n  0%,\n  60%,\n  75%,\n  90%,\n  100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n\n\n.fadeInUp {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.slideOutDown {\n    -webkit-animation-name: slideOutDown;\n    animation-name: slideOutDown;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n  }\n  @-webkit-keyframes slideOutDown {\n    0% {\n      -webkit-transform: translateY(-10%);\n      transform: translateY(-10%);\n    }\n    100% {\n      -webkit-transform: translateY(0);\n      transform: translateY(0);\n    }\n}","@import \"./animations.scss\";\n\n// Media Breakpoins\n\n$media-tablet: 768px;\n$media-mobile: 600px;\n\n:root{\n\n    // Main 4 colors pallet\n    --sdk-gloabl-primary-color:var(--chat-sdk-branding--global-primary-color);     // #4B4EDE;\n    --sdk-gloabl-secondary-color:var(--chat-sdk-branding--global-secondary-color);    // #EAECF0;\n    --sdk-global-primary-text:var(--chat-sdk-branding--global-primary-text);     // #101828;\n    --sdk-global-secondary-text:var(--chat-sdk-branding--global-secondary-text);      // #FFFFFF;\n    // End\n\n    // Main 4 colors for Panle and Widgets\n        --theme-panel-wigdet-primary-bg-color:var(--sdk-gloabl-primary-color);  // #175cd3;\n        --theme-panel-wigdet-secondary-bg-color:var(--sdk-gloabl-secondary-color);   // #EAECF0;\n        --theme-panel-wigdet-primary-text-color:var(--sdk-global-primary-text);  // #101828;\n        --theme-panel-wigdet-secondary-text-color:var(--sdk-global-secondary-text) ;   // #667085;\n    \n        // Extra colors\n        --panel-wigdet-primary-bg-color:var(--theme-panel-wigdet-primary-bg-color);\n        --panel-wigdet-secondary-bg-color:var(--theme-panel-wigdet-secondary-bg-color);\n        --panel-wigdet-primary-text-color:var(--theme-panel-wigdet-primary-text-color);\n        --panel-wigdet-secondary-text-color:var(--theme-panel-wigdet-secondary-text-color);\n        \n        --panel-wigdet-border-color:var(--panel-wigdet-secondary-bg-color);\n        --panel-wigdet-white-bg-color:var(--chat-sdk-branding--widget_panel-colors-bg_color);           //   #fff;\n        --panel-wigdet-white-text-color:#fff;\n        --panel-wigdet-left-menu-bg:var(--chat-sdk-branding--widget_panel-colors-bg_color);\n        --panel-wigdet-left-menu-selected-bg:var(--chat-sdk-branding--widget_panel-colors-sel_bg_color);\n        --panel-wigdet-left-menu-font-clr:var(--chat-sdk-branding--widget_panel-colors-color);\n        --panel-wigdet-left-menu-selected-font-clr:var(--chat-sdk-branding--widget_panel-colors-sel_color);\n\n    // End\n\n\n    // Font Family\n        --global-font-family: var(--chat-sdk-branding--global-font-family);   // \"Inter\";\n    // End\n\n    --sdk-global-theme-color:var(--sdk-gloabl-primary-color);\n    --sdk-gloabl-bg-secondary:var(--sdk-gloabl-secondary-color);\n    --sdk-global-white:var(--sdk-global-secondary-text);\n    --sdk-global-white-bg:var(--chat-sdk-branding--body-white-background);\n    --sdk-gloabl-text-color:var(--sdk-global-primary-text);\n    --sdk-gloabl-text-desc-color:var(--sdk-global-primary-text);\n    --sdk-gloabl-border-color:var(--sdk-gloabl-secondary-color);\n    --sdk-scrollbar-bg:var(--sdk-gloabl-bg-secondary);\n\n    // Avatar Variables\n        --avatar-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);  // var(--sdk-global-theme-color); \n        --avatar-send-msg-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color); // var(--sdk-global-theme-color);\n        --avatar-icon-color:var(--chat-sdk-branding--chat_bubble-bg-secondary_color);\n        --avatar-text-colr:var(--sdk-gloabl-text-color);\n    // End\n\n    //chat Widget Main\n        --chat-widget-box-shadow:0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n    // End\n    \n    // Agent Joined Template\n        --agent-joined-bg:var(--sdk-gloabl-bg-secondary);\n        --agent-joined-border:var(--sdk-gloabl-border-color);\n        --agent-joined-text-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Welcome screen Variables\n        --welcome-bg:var(--sdk-global-white-bg); //#F8FAFC\n        --welcome-shadow:0px 4px 12px 2px rgba(32,33,36,0.12);\n        --welcome-header-bg: var(--chat-sdk-branding--welcome_screen-background-color);  // var(--sdk-global-theme-color);\n        --welcome-header-text-color:var(--chat-sdk-branding--welcome_screen-top_fonts-color);  // var(--sdk-global-white);\n        --welcome-start-conv-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-bot-bg:var(--sdk-global-theme-color);\n        --welcome-start-conv-bot-title:var(--sdk-gloabl-text-color);\n        --welcome-start-conv-bot-desc:var(--sdk-gloabl-text-desc-color);\n        --welcome-start-conv-quick-btn-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-quick-btn-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-quick-btn-text:var(--sdk-gloabl-text-color);\n        --welcome-start-conv-search-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-search-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-button-bg:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_button_color); // var(--sdk-global-theme-color);\n        --welcome-start-conv-button-border:var(--sdk-global-theme-color);\n        --welcome-start-conv-button-color:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_text_color); //  var(--sdk-global-white);\n        --welcome-footer-bg:var(--chat-sdk-branding--welcome_screen-bottom_background-color);  // var(--sdk-global-theme-color);\n        --welecome-footer-text-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Chat Widget Header Variables;\n        --chat-widget-header-bg:var(--chat-sdk-branding--header-bg-bg_color);  // var(--sdk-global-white-bg);\n        --chat-widget-header-border:var(--sdk-gloabl-border-color);\n        --chat-widget-header-bg-large:linear-gradient(180deg, var(--sdk-global-theme-color) 0%, var(--sdk-global-theme-color) 40.67%, rgba(255, 255, 255, 0) 80.38%); // var(--sdk-global-theme-color)\n        --chat-widget-header-bg-large-info-bg:var(--sdk-global-white-bg);\n        --chat-widget-header-bg-large-actions-color:var(--sdk-global-white);\n        --chat-widget-header-bot-name-color:var(--chat-sdk-branding--header-title-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-header-bot-name-desc:var(--chat-sdk-branding--header-sub_title-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-header-actions-color:var(--chat-sdk-branding--header-icons-color);  // var(--sdk-gloabl-text-color);\n        --chat-widget-header-img-border:var(--sdk-global-white);\n    // End\n\n    // Chat Widget Body Variables;\n        --chat-widget-body-bg:var(--chat-sdk-branding--body-background-bg);  //  var(--sdk-global-white-bg);\n    // End\n\n    // Chat Widget Footer Variables;\n        --chat-widget-footer-bg: var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-bg:var(--chat-sdk-branding--footer-bg-bg_color); // var(--sdk-gloabl-bg-secondary);\n        --chat-widget-compose-bar-border:var(--sdk-gloabl-border-color);\n        --chat-widget-compose-bar-text-area-bg:var(--chat-sdk-branding--footer-compose_bar-bg_color);  // var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-text-area-border:var(--chat-sdk-branding--footer-compose_bar-outline-color); // var(--sdk-gloabl-border-color);\n        --chat-widget-compose-bar-text-area-color:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-text-area-placeholder-color:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-voice-speak-info-text:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-voice-icon-bg:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-icon-border:var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-voice-icon-color:var(--sdk-global-white);\n        --chat-widget-compose-bar-voice-speak-msg-bg:var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-voice-speak-msg-selected-bg:var(--sdk-gloabl-bg-secondary);\n        --chat-widget-compose-bar-voice-speak-msg-color:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-speak-msg-border:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-recording-animation-shadow:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 1px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 5px rgba(var(--sdk-global-theme-color), 0.2);\n        --chat-widget-compose-bar-voice-recording-animation-shadow-zoom:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2),0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2),0 0 0 6px rgba(var(--sdk-global-theme-color), 0),0 0 0 10px rgba(var(--sdk-global-theme-color), 0);\n        --chat-widget-compose-bar-menu-icon-color:var(--chat-sdk-branding--footer-menu_icon-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-other-icons:var(--chat-sdk-branding--footer-icons-color); // var(--sdk-gloabl-text-color);\n    // End\n\n    // Bot Bubble Messages Variables\n        --bot-bubble-text-color:var(--sdk-gloabl-text-color);\n        --bot-bubble-msg-bg:var(--chat-sdk-branding--body-bot_message-bg_color);  // var(--sdk-gloabl-bg-secondary);\n        --bot-bubble-msg-bg-hover:var(--chat-sdk-branding--body-bot_message-bg_color);  // var(--sdk-gloabl-bg-secondary);\n        --bot-bubble-msg-color:var(--chat-sdk-branding--body-bot_message-color);  // var(--sdk-gloabl-text-color);\n        --bot-bubble-img-border:var(--sdk-global-white-bg);\n    //End   \n\n    // Name\n        --name-color:var(--chat-sdk-branding--body-agent_message-title_color); // var(--sdk-global-primary-text)\n    // End\n\n    // Time stamp\n        --time-stamp-color:var(--chat-sdk-branding--body-time_stamp-color);     // var(--sdk-global-primary-text)\n    //End\n\n    // Agent Bubble Messages Variables\n        --agent-bubble-text-color:var(--sdk-gloabl-text-color);\n        --agent-bubble-msg-bg:var(--chat-sdk-branding--body-user_message-bg_color);  // var(--sdk-global-theme-color);\n        --agent-bubble-msg-bg-hover:var(--chat-sdk-branding--body-user_message-bg_color);  // var(--sdk-global-theme-color);\n        --agent-bubble-msg-color:var(--chat-sdk-branding--body-user_message-color);  // var(--sdk-global-white);\n        --agent-bubble-img-border:var(--sdk-global-white-bg);\n        --agent-bubble-read-status-icon-color:#22C55E;\n    //End\n\n    // Date Seperator styles\n        --date-seperator-bg:var(--sdk-gloabl-bg-secondary);\n        --date-seperator-border:var(--sdk-gloabl-border-color);\n        --date-seperator-line-border:var(--sdk-gloabl-border-color);\n        --date-seperator-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Buttons\n        --button-bg-color: var(--chat-sdk-branding--body-buttons-bg_color);\n        --button-text-color: var(--chat-sdk-branding--body-buttons-color);\n    // End\n\n    // Template Styles\n\n        // Button Template\n        --button-temp-bg:var(--sdk-global-white-bg);\n        --button-temp-border:var(--sdk-gloabl-border-color);\n        --button-temp-color:var(--sdk-gloabl-text-color);\n        --button-temp-bg-hover:var(--sdk-gloabl-bg-secondary);\n        --button-temp-bg-variation-1:var(--sdk-gloabl-bg-secondary);\n        --button-temp-variation-1-border:transparent;\n        --button-temp-variation-1-color:var(--button-bg-color);   // --sdk-global-theme-color\n        --button-temp-bg-variation-1-hover:linear-gradient(0deg, rgba(75, 78, 222, 0.07) 0%, rgba(75, 78, 222, 0.07) 100%), var(--sdk-gloabl-bg-secondary);\n        --button-temp-bg-variation-2:var(--button-bg-color);   // --sdk-global-theme-color\n        --button-temp-variation-2-border:var(--button-bg-color);  // --sdk-global-theme-color\n        --button-temp-variation-2-color:var(--button-text-color);  // --sdk-global-white\n        --button-temp-bg-variation-2-hover:linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), var(--button-bg-color);  // --sdk-global-theme-color\n        // End\n\n        // Card Template\n        --card-main-wrapper-bg:var(--sdk-gloabl-bg-secondary);\n        --card-main-wrapper-border:var(--sdk-gloabl-border-color);\n        --card-heading-title:var(--sdk-gloabl-text-color);\n        --card-temp-border:var(--sdk-gloabl-border-color);\n        --card-temp-bg:var(--sdk-global-white-bg);\n        --card-temp-color:var(--sdk-gloabl-text-color);\n        --card-temp-h1-color:var(--sdk-gloabl-text-color);\n        --card-temp-p-color:var(--sdk-gloabl-text-color);   \n        --card-temp-view-more-bg:var(--sdk-global-white-bg);\n        --card-temp-view-more-color:var(--sdk-global-theme-color);\n        --card-temp-view-more-border:var(--sdk-global-theme-color);\n        --card-temp-border-divided-bg:var(--sdk-gloabl-border-color);\n        // End     \n\n        // Form Template\n        --form-temp-bg:var(--sdk-gloabl-bg-secondary);\n        --form-temp--text-color:var(--sdk-gloabl-text-color);\n        --form-temp-input-bg:var(--sdk-global-white-bg);\n        --form-temp-input-box-shadow:0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n        --form-temp-input-placeholder:var(--sdk-gloabl-text-color);\n        \n        // Table Template\n        --table-border:var(--sdk-gloabl-border-color);\n        --table-header-text-color:var(--sdk-gloabl-text-color);\n        --table-body-tr-bg:var(--sdk-gloabl-bg-secondary);\n        --table-desc-text-color:var(--sdk-gloabl-text-color);\n        // End\n\n        // Radio Template\n            --radio-desc-text-clr:var(--sdk-gloabl-text-color);\n            --radio-border:var(--sdk-gloabl-border-color);\n            --radio-bg:var(--sdk-global-white-bg);\n            --radio-checked-shadow:inset 0 0 0 6px var(--sdk-global-white-bg);\n        // End\n}   \n\n\n\n// STANDARD SIZES\n$font-s-5:0.3125rem;\n$font-s-6:0.375rem;\n$font-s-7:0.4375rem;\n$font-s-8:0.5rem;\n$font-s-9:0.5625rem;\n$font-s-10:0.625rem;\n$font-s-11:0.6875rem;\n$font-s-12:0.75rem;\n$font-s-13:0.8125rem;\n$font-s-14:0.875rem;\n$font-s-15:0.9375rem;\n$font-s-16:1rem;\n$font-s-17:1.0625rem;\n$font-s-18:1.125rem;\n$font-s-19:1.1875rem;\n$font-s-20:1.25rem;\n$font-s-21:1.3125rem;\n$font-s-22:1.375rem;\n$font-s-23:1.4375rem;\n$font-s-24:1.5rem;\n$font-s-25:1.5625rem;\n$font-s-26:1.625rem;\n$font-s-27:1.6875rem;\n$font-s-28:1.75rem;\n$font-s-29:1.8125rem;\n$font-s-30:1.875rem;\n$font-s-31:1.9375rem;\n$font-s-32:2rem;\n$font-s-33:2.0625rem;\n$font-s-40:2.5rem;\n\n// Button primary\n\n.kr-button-primary{\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    width: 100%;\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    background: var(--button-temp-bg-variation-2);\n    border: 1px solid var(--button-temp-variation-2-border);\n    color: var(--button-temp-variation-2-color);\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-temp-bg-variation-2-hover);\n    }\n    &:disabled{\n        opacity: 0.5;\n        pointer-events: none;\n    }\n}\n.kr-button-secondary{\n    width: 100%;\n    background: var(--button-temp-bg);\n    border: 1px solid var(--button-temp-border);\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    color: var(--button-temp-color);\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-temp-bg-hover);\n    }\n}\n\n.kr-button-blue-light{\n    width: 100%;\n    background: var(--button-bg-color);\n    border: 1px solid var(--button-bg-color);\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    color: var(--button-text-color);   // #2B75E4\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    svg{\n        path{\n            fill: var(--button-bg-color);  // #2B75E4\n        }\n    }\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-bg-color);\n    }\n}\n\n.kore-chat-window-main-section{\n    .chart-disp-val{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n    .chart-axis-line{\n        stroke: var(--sdk-gloabl-text-color);\n    }\n    .legend-title{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n    polyline{\n        stroke: var(--sdk-gloabl-text-color);\n    }\n    .mouse-per-line{\n        text{\n            fill: var(--sdk-gloabl-text-color);\n            font-size: 12px;\n        }\n    }\n    .legend-value{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n}","/* -------------------------------------------------\n    Datepicker buttons\n   ------------------------------------------------- */\n\n.air-datepicker-buttons {\n  display: grid;\n  grid-auto-columns: 1fr;\n  grid-auto-flow: column;\n}\n\n.air-datepicker-button {\n  display: inline-flex;\n  color: var(--adp-btn-color);\n  border-radius: var(--adp-btn-border-radius);\n  cursor: pointer;\n  height: var(--adp-btn-height);\n  border: none;\n  background: rgba(255, 255, 255, 0);\n  \n  &:hover {\n    color: var(--adp-btn-color-hover);\n    background: var(--adp-btn-background-color-hover);\n  }\n\n  &:focus {\n    color: var(--adp-btn-color-hover);\n    background: var(--adp-btn-background-color-hover);\n    outline: none;\n  }\n\n  &:active {\n    background: var(--adp-btn-background-color-active);\n  }\n\n  span {\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n  }\n}\n","/* -------------------------------------------------\n    Datepicker nav\n   ------------------------------------------------- */\n\n.air-datepicker-nav {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 0px solid var(--adp-border-color-inner);\n  min-height: var(--adp-nav-height);\n  padding: var(--adp-padding);\n  box-sizing: content-box;\n\n  .-only-timepicker- & {\n    display: none;\n  }\n}\n.air-datepicker-nav--title,\n.air-datepicker-nav--action {\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n}\n\n/*  Navigation action\n   ------------------------------------------------- */\n\n.air-datepicker-nav--action {\n  width: var(--adp-nav-action-size);\n  border-radius: var(--adp-border-radius);\n  user-select: none;\n\n  &:hover {\n    background: var(--adp-background-color-hover);\n  }\n\n  &:active {\n    background: var(--adp-background-color-active);\n  }\n\n  &.-disabled- {\n    visibility: hidden;\n  }\n\n  svg {\n    width: 32px;\n    height: 32px;\n  }\n\n  path {\n    fill: none;\n    stroke: var(--adp-nav-arrow-color);\n    stroke-width: 2px;\n  }\n}\n\n/*  Navigation title\n   ------------------------------------------------- */\n\n.air-datepicker-nav--title {\n  border-radius: var(--adp-border-radius);\n  padding: 0 8px;\n  color: var(--adp-color);\n  text-align: center;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n\n  i {\n    font-style: normal;\n    color: var(--adp-color);\n    margin-left: .3em;\n  }\n\n  &:hover {\n    background: var(--adp-background-color-hover);\n  }\n\n  &:active {\n    background: var(--adp-background-color-active);\n  }\n\n  &.-disabled- {\n    cursor: default;\n    background: none;\n  }\n}\n\n\n","@import \"./_objects\";\n\n/* -------------------------------------------------\n    Datepicker cell\n   ------------------------------------------------- */\n\n.air-datepicker-cell {\n  border-radius: var(--adp-cell-border-radius);\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  display: flex;\n  width: 40px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  &.-focus- {\n    background: var(--adp-cell-background-color-hover);\n  }\n\n  &.-current- {\n    color: var(--adp-color-current-date);\n    background: var(--adp-background-color-hover);\n    &::before{\n      content: \"\";\n      position: absolute;\n      background: var(--sdk-global-theme-color);\n      bottom: 4px;\n      width: 6px;\n      height: 6px;\n      border-radius: 100%;\n      flex-shrink: 0;  \n    }\n    &.-focus- {\n      color: var(--adp-color);\n    }\n\n    &.-in-range- {\n      color: var(--adp-color-current-date);\n    }\n  }\n\n  &.-disabled- {\n    cursor: default;\n    color: var(--adp-color-disabled);\n\n    &.-focus- {\n      color: var(--adp-color-disabled);\n    }\n\n    &.-in-range- {\n      color: var(--adp-color-disabled-in-range);\n      background-color: var(--adp-background-color);\n    }\n\n    &.-current- {\n      &.-focus- {\n        color:var(--adp-color-disabled);\n      }\n    }\n  }\n\n  &.-in-range- {\n    background: var(--adp-cell-background-color-in-range);\n\n    &:hover {\n      background: var(--adp-cell-background-color-in-range-hover);\n    }\n  }\n\n  &.-range-from- {\n    background-color: var(--adp-cell-background-color-in-range);\n    border-radius: var(--adp-cell-border-radius);\n  }\n  &.-range-to- {\n    background-color: var(--adp-cell-background-color-in-range);\n    border-radius: var(--adp-cell-border-radius);\n  }\n\n  &.-range-to-.-range-from- {\n    border-radius: var(--adp-cell-border-radius);\n  }\n\n  &.-selected- {\n    color: var(--sdk-global-white);\n    border: none;\n    background: var(--adp-cell-background-color-selected);\n\n    &.-current- {\n      color: var(--sdk-global-white);\n      background: var(--adp-cell-background-color-selected);\n    }\n\n    &.-focus- {\n      background: var(--adp-cell-background-color-selected-hover);\n    }\n  }\n  &.-month-{\n    width: auto;\n    height: auto;\n    margin:2px;\n    border-radius: 4px !important;\n  }\n  &.-year-{\n    width: auto;\n    height: auto;\n    margin:2px;\n    border-radius: 4px !important;\n  }\n}\n\n\n/*  Day cell\n   ------------------------------------------------- */\n\n.air-datepicker-cell.-day- {\n  &.-other-month-{\n    @extend %otherMonth;\n  }\n}\n\n/*  Year cell\n   ------------------------------------------------- */\n\n.air-datepicker-cell.-year- {\n  &.-other-decade-{\n    @extend %otherMonth;\n  }\n}\n","/* -------------------------------------------------\n    Timepicker\n   ------------------------------------------------- */\n\n$rangeTrackBg: #dedede;\n$rangeThumbSize: 12px;\n\n@mixin trackSelector {\n  &::-webkit-slider-runnable-track {\n    @content;\n  }\n\n  &::-moz-range-track {\n    @content;\n  }\n\n  &::-ms-track {\n    @content;\n  }\n}\n\n@mixin thumbSelector {\n  &::-webkit-slider-thumb {\n    @content;\n  }\n\n  &::-moz-range-thumb {\n    @content;\n  }\n\n  &::-ms-thumb {\n    @content;\n  }\n}\n\n@mixin thumb {\n  box-sizing: border-box;\n  height: $rangeThumbSize;\n  width: $rangeThumbSize;\n  border-radius: 3px;\n  border: 1px solid var(--adp-time-track-color);\n  background: #fff;\n  cursor: pointer;\n\n  transition: background var(--adp-transition-duration);\n}\n\n@mixin track {\n  border: none;\n  height: var(--adp-time-track-height);\n  cursor: pointer;\n  color: transparent;\n  background: transparent;\n}\n\n.air-datepicker-time {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  grid-column-gap: 12px;\n  align-items: center;\n  position: relative;\n  // padding: 0 var(--adp-time-padding-inner);\n  margin: 18px;\n  padding: 50px 0;\n\n  .-only-timepicker- & {\n    border-top: none;\n  }\n}\n\n.air-datepicker-time--sliders {\n}\n\n.air-datepicker-time--current {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  font-size: 14px;\n  text-align: center;\n}\n\n.air-datepicker-time--current-colon {\n  margin: 0 2px 3px;\n  line-height: 1;\n}\n\n.air-datepicker-time--current-hours,\n.air-datepicker-time--current-minutes {\n  line-height: 1;\n  font-size: 19px;\n  font-family: \"Century Gothic\", CenturyGothic, AppleGothic, sans-serif;\n  position: relative;\n  z-index: 1;\n\n  &:after {\n    content: '';\n    background: var(--adp-background-color-hover);\n    border-radius: var(--adp-border-radius);\n    position: absolute;\n    left: -2px;\n    top: -3px;\n    right: -2px;\n    bottom: -2px;\n    z-index: -1;\n    opacity: 0;\n  }\n\n  &.-focus- {\n    &:after {\n      opacity: 1;\n    }\n  }\n}\n\n.air-datepicker-time--current-ampm {\n  text-transform: uppercase;\n  align-self: flex-end;\n  color: var(--adp-time-day-period-color);\n  margin-left: 6px;\n  font-size: 11px;\n  margin-bottom: 1px;\n}\n\n.air-datepicker-time--row {\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  height: 17px;\n  background:\n    linear-gradient(to right,var(--adp-time-track-color), var(--adp-time-track-color))\n    left 50%/100% var(--adp-time-track-height) no-repeat;\n\n  &:first-child {\n    margin-bottom: 4px;\n  }\n\n  input[type='range'] {\n    background: none;\n    cursor: pointer;\n    flex: 1;\n    height: 100%;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    -webkit-appearance: none;\n\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n    }\n\n    &::-ms-tooltip {\n      display: none;\n    }\n\n    &:hover {\n      @include thumbSelector() {\n        border-color: var(--adp-time-track-color-hover);\n      }\n    }\n\n    &:focus {\n      outline: none;\n\n      @include thumbSelector() {\n        background: var(--adp-cell-background-color-selected);\n        border-color: var(--adp-cell-background-color-selected);\n      }\n    }\n\n    //  Thumb\n    // -------------------------------------------------\n\n    @include thumbSelector() {\n      @include thumb;\n    }\n\n    &::-webkit-slider-thumb {\n      margin-top: calc(var(--adp-time-thumb-size) / 2 * -1);\n    }\n\n    //  Track\n    // -------------------------------------------------\n    @include trackSelector() {\n      @include track;\n    }\n\n    &::-ms-fill-lower {\n      background: transparent;\n    }\n    &:focus::-ms-fill-lower {\n\n    }\n    &::-ms-fill-upper {\n      background: transparent;\n    }\n    &:focus::-ms-fill-upper {\n\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
